/* eslint-disable max-len */
import { DimensionUnits, Product } from '@app-domains/content-blocks/components/product-card/product-card.types'
import {
    AccordionFragment,
    AddressInput,
    AssortmentFragment,
    CarouselSlideFragment,
    CategoryFragment,
    CompleteBrandFragment,
    ContentCategoryFragment,
    DebtorFragment,
    DownloadEnum,
    EventFragment,
    IconEnum,
    ImageComponentFragment,
    ImageFragment,
    ImagePositionEnum,
    IndividualCategoryFragment,
    LinkFragment,
    LinkTargetEnum,
    MinimalAssortmentsFragment,
    NewsFragment,
    NewsLetter,
    NewsLetterTypeEnum,
    OrderStateEnum,
    PageLayoutEnum,
    PageLinksFragment,
    PageQuery,
    PaginatorInfoFragment,
    ParagraphsFragment,
    ParagraphsLayoutEnum,
    PaymentConditionFragment,
    ProductFragment,
    ProductImageTypeEnum,
    ProjectSlideFragment,
    QuoteFragment,
    SaleStatisticsFragment,
    Seo,
    ShoppingCartFragment,
    SimpleOrderFragment,
    SimpleProductFragment,
    SimpleThemeFragment,
    StatisticTypeEnum,
    SubFooterLinkFragment,
    SuggestedRetailPricesEnum,
    ThemeFragment,
    UniqueSellingPointFragment,
    VideoFragment,
} from '@app-graphql/schema'

import { Translated } from '@app-types/common.types'
import { ShipmentSegment } from '@app-domains/checkout/types/checkout.types'
import { FeatureHighlight } from '@app-content-blocks/feature-highlight/feature-highlight.types'

export * from './mock-hits'

export const mockBrandLogos = [
    'assets/images/brands/basiclabel-logo.svg',
    'assets/images/brands/bepurehome-logo.svg',
    'assets/images/brands/exotan-logo.svg',
    'assets/images/brands/pip-studio-logo.svg',
    'assets/images/brands/vtwonen-logo.svg',
    'assets/images/brands/woood-grey-logo.svg',
]

export const mockImages = [
    'assets/images/mock/img.webp',
    'assets/images/mock/img_1.webp',
    'assets/images/mock/img_2.webp',
    'assets/images/mock/img_3.webp',
    'assets/images/mock/img_4.webp',
    'assets/images/mock/img_5.webp',
    'assets/images/mock/img_6.webp',
    'assets/images/mock/img_7.webp',
    'assets/images/mock/img_8.webp',
]

export const mockImage = (width: number, height?: number): ImageFragment => {
    return {
        __typename: 'Image',
        url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
        alt: 'Test Image',
        height: height ?? width,
        width: width,
        name: 'Test Image',
        caption: 'Test Image',
        previewUrl: `https://place-puppy.com/${ width }x${ height ?? width }`,
        provider: 'Test',
    }
}

export const mockCarouselSlides: CarouselSlideFragment[] = [
    {
        link: {
            link: 'https://deeekhoorn.com/nl/products/bepurehome',
            label: 'Ontdek onze andere winkel',
            target: LinkTargetEnum.Blank,
        },
        backgroundImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        mainImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        text: 'Woood',
        title: 'Robust and Modern',
        subtitle: 'The concept of WOOOD is clear: they stand for robust, ' +
            'contemporary and attractive home furnishings that are affordable for everyone. ' +
            'WOOOD is a specialist in the field of wooden furniture, but also has beautiful upholstered sofas' +
            ' and metal chairs.',
    },
    {
        link: {
            link: 'https://deeekhoorn.com/nl/products/bepurehome',
            label: 'Ontdek onze andere winkel',
            target: LinkTargetEnum.Blank,
        },
        backgroundImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        mainImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        text: 'Woood',
        title: 'Robust and Modern',
        subtitle: 'The concept of WOOOD is clear: they stand for robust, ' +
            'contemporary and attractive home furnishings that are affordable for everyone. ' +
            'WOOOD is a specialist in the field of wooden furniture, but also has beautiful upholstered sofas' +
            ' and metal chairs.',
    },
    {
        link: {
            link: 'https://deeekhoorn.com/nl/products/bepurehome',
            label: 'Ontdek onze andere winkel',
            target: LinkTargetEnum.Blank,
        },
        backgroundImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockBrandLogos[Math.floor(Math.random() * (4 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        mainImage: {
            __typename: 'ImageComponent',
            desktop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            laptop: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            mobile: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
            tablet: {
                __typename: 'PositionedImage',
                imagePosition: ImagePositionEnum.Center,
                image: {
                    __typename: 'Image',
                    url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                    alt: 'Test Image',
                    height: 400,
                    width: 400,
                    name: 'Test Image',
                    caption: 'Test Image',
                    previewUrl: 'https://place-puppy.com/400x400',
                    provider: 'Test',
                },
            },
        },
        text: 'Woood',
        title: 'Robust and Modern',
        subtitle: 'The concept of WOOOD is clear: they stand for robust, ' +
            'contemporary and attractive home furnishings that are affordable for everyone. ' +
            'WOOOD is a specialist in the field of wooden furniture, but also has beautiful upholstered sofas' +
            ' and metal chairs.',
    },
]

export const mockResponsiveImage = (width: number, height?: number): ImageComponentFragment => {
    return {
        __typename: 'ImageComponent',
        desktop: {
            __typename: 'PositionedImage',
            imagePosition: ImagePositionEnum.Center,
            image: {
                __typename: 'Image',
                url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                alt: 'Test Image',
                height: height ?? width,
                width: width,
                name: 'Test Image',
                caption: 'Test Image',
                previewUrl: `https://place-puppy.com/${ width }x${ height ?? width }`,
                provider: 'Test',
            },
        },
        laptop: {
            __typename: 'PositionedImage',
            imagePosition: ImagePositionEnum.Center,
            image: {
                __typename: 'Image',
                url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                alt: 'Test Image',
                height: height ?? width,
                width: width,
                name: 'Test Image',
                caption: 'Test Image',
                previewUrl: `https://place-puppy.com/${ width }x${ height ?? width }`,
                provider: 'Test',
            },
        },
        mobile: {
            __typename: 'PositionedImage',
            imagePosition: ImagePositionEnum.Center,
            image: {
                __typename: 'Image',
                url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                alt: 'Test Image',
                height: height ?? width,
                width: width,
                name: 'Test Image',
                caption: 'Test Image',
                previewUrl: `https://place-puppy.com/${ width }x${ height ?? width }`,
                provider: 'Test',
            },
        },
        tablet: {
            __typename: 'PositionedImage',
            imagePosition: ImagePositionEnum.Center,
            image: {
                __typename: 'Image',
                url: mockImages[Math.floor(Math.random() * (8 - 1 + 1)) + 1],
                alt: 'Test Image',
                height: height ?? width,
                width: width,
                name: 'Test Image',
                caption: 'Test Image',
                previewUrl: `https://place-puppy.com/${ width }x${ height ?? width }`,
                provider: 'Test',
            },
        },
    }
}

export const mockLink = (label: string = 'Test'): LinkFragment => ({
    link: 'http://google.com',
    label,
    target: LinkTargetEnum.Self,
})

export const mockVideo: VideoFragment = {
    __typename: 'Video',
    url: 'assets/videos/file_example_MP4_1280_10MG.mp4',
    caption: 'demo',
    name: 'demo',
    previewUrl: 'assets/videos/file_example_MP4_1280_10MG.mp4',
    provider: 'demo',
}

export const mockQuotes: QuoteFragment[] = [
    {
        title: 'Ceo JD BV',
        name: 'John Doe',
        photo: mockImage(64),
        text: 'De Eekhoorn has proven to be a strong partner when setting up our new hotel building. We received advice at every step and the result is astonishing',
    },
    {
        title: 'Ceo JD BV',
        name: 'John Doe',
        photo: mockImage(64),
        text: 'De Eekhoorn has proven to be a strong partner when setting up our new hotel building. We received advice at every step and the result is astonishing',
    },
    {
        title: 'Ceo JD BV',
        name: 'John Doe',
        photo: mockImage(64),
        text: 'De Eekhoorn has proven to be a strong partner when setting up our new hotel building. We received advice at every step and the result is astonishing',
    },
]

export const mockUSPs: UniqueSellingPointFragment[] = [
    {
        icon: IconEnum.Sofa,
        title: 'Affordable',
        subtitle: 'furniture & accessories',
    },
    {
        icon: IconEnum.User,
        title: 'More than 40 years',
        subtitle: 'of experience',
    },
    {
        icon: IconEnum.ExperienceCenter,
        title: '2,000 m2 to experience',
        subtitle: 'the collection for yourself',
    },
]

export const mockSubfooterLinks: SubFooterLinkFragment = {
    __typename: 'SubFooterLink',
    links: [
        {
            subtitle: 'About us',
            title: 'Curious about what makes us proud?',
            link: {
                link: '/p/about-us',
                label: 'Read our Story',
                target: LinkTargetEnum.Blank,
            },
            image: mockResponsiveImage(400),
        },
        {
            subtitle: 'Need help',
            title: 'Do you have a question? Can we help you?',
            link: {
                link: '/p/contact',
                label: 'Contact us',
                target: LinkTargetEnum.Blank,
            },
            image: mockResponsiveImage(400),
        },
    ],
}

export const mockProduct: Translated<ProductFragment> = {
    __typename: 'Product',
    uniqueHash: '1',
    assetUrl3dModel: 'https://tets.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
    statusTranslations: {
        en: 'test',
        nl: 'test',
        de: 'test',
        fr: 'test',
    },
    fullDescription: '- Elegant, friendly dining chair- Velvet (100% PES) with black iron frame- Comfortable shell design- H 82 cm x W 57 cm x D 53 cmThis attractive Dusk dining chair is from the collection of the Dutch brands WOOOD. Dusk has an elegant and friendly, slender look and an active seat. The subtle greyish hue makes Dusk easy to combine in various interior styles. Combine the Dusk dining chair with a chic dark colour palette or bring cosiness to a white interior with the greyish hue.MaterialThe dining chair is upholstered in a rich velvet fabric (100% polyester). With a Martindale of 25,000, Dusk is suitable for intensive home use but it is recommended to avoid sharp objects. The base of the chair is made of iron with a matte black finish.DimensionsThe Dusk dining chair has a seat height of 48 cm, a seat depth of 43 cm and the seat width is 48 cm at the front of the seat and 25 cm at the back of the seat. The armrests are 73 cm high and 2.5 cm wide. The leg has a height of 43 cm. The dining chair has a maximum weight capacity of 150 kg. MaintenanceStripes in the velvet fabric? This can happen due to the pressure that the fabric has been put under by the packaging. Fortunately you can easily solve this yourself by steaming the fabric (use your steam iron for example) or by spraying it with water. Then you can brush the fabric with a clean soft brush. The poles of the fabric will thus be restored! You keep velvet clean weekly with a special velvet brush.DeliveryFor hard floors, place felt glides under the legs. This prevents damage to the floor. The article is delivered as a simple construction kit with clear assembly instructions.',
    name: 'DUSK DINING CHAIR VELVET OLD PINK',
    slug: 'dusk-dining-chair-velvet-old-pink',
    shortDescription: '- Elegant, friendly dining chair\n- Velvet (100% PES) with black iron frame\n- Comfortable' +
        ' shell' +
        ' design\n- H 82 cm x W 57 cm x D 53 cm\n\nThis attractive Dusk dining chair is from the collection of the Dutch brands WOOOD. Dusk has an elegant and friendly, slender look and an active seat. The subtle greyish hue makes Dusk easy to combine in various interior styles. Combine the Dusk dining chair with a chic dark colour palette or bring cosiness to a white interior with the greyish hue.\n\nMaterial\nThe dining chair is upholstered in a rich velvet fabric (100% polyester). With a Martindale of 25,000, Dusk is suitable for intensive home use but it is recommended to avoid sharp objects. The base of the chair is made of iron with a matte black finish.\n\nDimensions\nThe Dusk dining chair has a seat height of 48 cm, a seat depth of 43 cm and the seat width is 48 cm at the front of the seat and 25 cm at the back of the seat. The armrests are 73 cm high and 2.5 cm wide. The leg has a height of 43 cm. The dining chair has a maximum weight capacity of 150 kg. \n\nMaintenance\nStripes in the velvet fabric? This can happen due to the pressure that the fabric has been put under by the packaging. Fortunately you can easily solve this yourself by steaming the fabric (use your steam iron for example) or by spraying it with water. Then you can brush the fabric with a clean soft brush. The poles of the fabric will thus be restored! You keep velvet clean weekly with a special velvet brush.\n\nDelivery\nFor hard floors, place felt glides under the legs. This prevents damage to the floor. The article is delivered as a simple construction kit with clear assembly instructions.',
    status: 'SALE',
    brand: { name: 'BasicLabel' },
    categories: [],
    downloads: [
        {
            title: 'Manual',
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
            type: DownloadEnum.Manual,
        },
    ],
    suggestedRetailPrices: [
        {
            price: 100,
            standardPrice: 100,
            type: SuggestedRetailPricesEnum.Nl,
        },
    ],
    ean: '8714713118120',
    codeLocal: '200292-C',
    country: 'Not yet available.',
    group: 'DINING CHAIRS & BENCHES',
    range: 'COLLECTION',
    totalPackages: 1,
    packages: [
        {
            ean: '8714713118120',
            productCode: '131123',
            weightInKg: 123,
            depthInMm: 123,
            lengthMm: 123,
            volM3: 123,
            widthMm: 123,
            quantity: 123,
        },
    ],
    dimensions: [
        {
            dimension: 6.8,
            label: 'weight',
        },
        {
            dimension: 53,
            label: 'length',
        },
        {
            dimension: 57,
            label: 'width',
        },
        {
            dimension: 82,
            label: 'height',
        },
    ],
    images: [
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.Front,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
            alt: 'Image 1 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.Group,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_2.jpg',
            alt: 'Image 2 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.Default,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_3.jpg',
            alt: 'Image 3 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.CloseUp,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_4.jpg',
            alt: 'Image 4 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.CloseUp,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_5.jpg',
            alt: 'Image 5 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.Group,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_6.jpg',
            alt: 'Image 6 - ImageUrl',
        },
        {
            __typename: 'ProductImage',
            type: ProductImageTypeEnum.CloseUp,
            url: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120_7.jpg',
            alt: 'Image 7 - ImageUrl',
        },
    ],
    variants: {
        types: [],
        materials: [],
        colors: [],
    },
    colors: [
        {
            __typename: 'Color',
            translations: {
                nl: 'red',
                de: 'red',
                fr: 'red',
                en: 'red',
            },
            presentation: '#FF0000',
        },
        {
            __typename: 'Color',
            translations: {
                nl: 'green',
                de: 'green',
                fr: 'green',
                en: 'green',
            },
            presentation: '#44e000',
        },
    ],
    subColors: [
        {
            __typename: 'Color',
            translations: {
                nl: 'red',
                de: 'red',
                fr: 'red',
                en: 'red',
            },
            presentation: '#FF0000',
        },
        {
            __typename: 'Color',
            translations: {
                nl: 'green',
                de: 'green',
                fr: 'green',
                en: 'green',
            },
            presentation: '#44e000',
        },
    ],
    materials: [{
        nl: 'Wood',
        de: 'Wood',
        fr: 'Wood',
        en: 'Wood',
    }],
    subMaterials: [{
        nl: 'Wood',
        de: 'Wood',
        fr: 'Wood',
        en: 'Wood',
    }],
    videos: [],
    translations: {
        en: {
            fullDescription: '- Elegant, friendly dining chair- Velvet (100% PES) with black iron frame- Comfortable shell design- H 82 cm x W 57 cm x D 53 cmThis attractive Dusk dining chair is from the collection of the Dutch brands WOOOD. Dusk has an elegant and friendly, slender look and an active seat. The subtle greyish hue makes Dusk easy to combine in various interior styles. Combine the Dusk dining chair with a chic dark colour palette or bring cosiness to a white interior with the greyish hue.MaterialThe dining chair is upholstered in a rich velvet fabric (100% polyester). With a Martindale of 25,000, Dusk is suitable for intensive home use but it is recommended to avoid sharp objects. The base of the chair is made of iron with a matte black finish.DimensionsThe Dusk dining chair has a seat height of 48 cm, a seat depth of 43 cm and the seat width is 48 cm at the front of the seat and 25 cm at the back of the seat. The armrests are 73 cm high and 2.5 cm wide. The leg has a height of 43 cm. The dining chair has a maximum weight capacity of 150 kg. MaintenanceStripes in the velvet fabric? This can happen due to the pressure that the fabric has been put under by the packaging. Fortunately you can easily solve this yourself by steaming the fabric (use your steam iron for example) or by spraying it with water. Then you can brush the fabric with a clean soft brush. The poles of the fabric will thus be restored! You keep velvet clean weekly with a special velvet brush.DeliveryFor hard floors, place felt glides under the legs. This prevents damage to the floor. The article is delivered as a simple construction kit with clear assembly instructions.',
            name: 'DUSK DINING CHAIR VELVET OLD PINK',
            slug: 'dusk-dining-chair-velvet-old-pink',
            shortDescription: '- Elegant, friendly dining chair\n- Velvet (100% PES) with black iron frame\n-' +
                ' Comfortable shell design\n- H 82 cm x W 57 cm x D 53 cm\n\nThis attractive Dusk dining chair is from the collection of the Dutch brands WOOOD. Dusk has an elegant and friendly, slender look and an active seat. The subtle greyish hue makes Dusk easy to combine in various interior styles. Combine the Dusk dining chair with a chic dark colour palette or bring cosiness to a white interior with the greyish hue.\n\nMaterial\nThe dining chair is upholstered in a rich velvet fabric (100% polyester). With a Martindale of 25,000, Dusk is suitable for intensive home use but it is recommended to avoid sharp objects. The base of the chair is made of iron with a matte black finish.\n\nDimensions\nThe Dusk dining chair has a seat height of 48 cm, a seat depth of 43 cm and the seat width is 48 cm at the front of the seat and 25 cm at the back of the seat. The armrests are 73 cm high and 2.5 cm wide. The leg has a height of 43 cm. The dining chair has a maximum weight capacity of 150 kg. \n\nMaintenance\nStripes in the velvet fabric? This can happen due to the pressure that the fabric has been put under by the packaging. Fortunately you can easily solve this yourself by steaming the fabric (use your steam iron for example) or by spraying it with water. Then you can brush the fabric with a clean soft brush. The poles of the fabric will thus be restored! You keep velvet clean weekly with a special velvet brush.\n\nDelivery\nFor hard floors, place felt glides under the legs. This prevents damage to the floor. The article is delivered as a simple construction kit with clear assembly instructions.',
        },
        fr: {
            fullDescription: '- Chaise de salle à manger élégante et conviviale- Velours (100% PES) avec cadre en fer noir- Design confortable de la coque- H 82 cm x L 57 cm x P 53 cmCette jolie chaise de salle à manger Dusk est issue de la collection de la marque néerlandaise WOOOD. Dusk a une apparence mince, élégante et conviviale, et un siège actif. Grâce à sa teinte grisâtre subtile, Dusk s\'intègre facilement dans différents styles d\'intérieur. Associez la chaise de salle à manger Dusk à une palette de couleurs foncées chic ou apportez de la convivialité à un intérieur blanc grâce à sa teinte grisâtre.MatériauLa chaise de salle à manger est recouverte d\'un riche tissu en velours (100% polyester). Avec un Martindale de 25 000, Dusk convient à un usage domestique intensif mais il est recommandé d\'éviter les objets pointus. La base de la chaise est en fer avec une finition noire mate.DimensionsLa chaise de salle à manger Dusk a une hauteur d\'assise de 48 cm, une profondeur d\'assise de 43 cm et une largeur d\'assise de 48 cm à l\'avant du siège et de 25 cm à l\'arrière du siège. Les accoudoirs ont une hauteur de 73 cm et une largeur de 2,5 cm. Le pied a une hauteur de 43 cm. La chaise de salle à manger a une capacité de charge maximale de 150 kg. MaintenanceDes rayures dans le tissu en velours ? Cela peut se produire en raison de la pression exercée sur le tissu par l\'emballage. Heureusement, vous pouvez facilement résoudre ce problème vous-même en passant le tissu à la vapeur (utilisez votre fer à vapeur par exemple) ou en l\'aspergeant d\'eau. Vous pouvez ensuite brosser le tissu avec une brosse douce et propre. Les pôles du tissu sont ainsi restaurés ! Vous nettoyez le velours chaque semaine avec une brosse spéciale velours.Date de livraisonPour les sols durs, placez des patins en feutre sous les pieds. Cela évite d\'endommager le sol. L\'article est livré sous forme de kit de construction simple avec des instructions de montage claires.',
            name: 'DUSK CHAISE VELOURS VELOURS VIEUX ROSA',
            slug: 'dusk-chaise-velours-velours-vieux-rosa',
            shortDescription: '- Chaise de salle à manger élégante et conviviale\n- Velours (100% PES) avec cadre' +
                ' en' +
                ' fer' +
                ' noir\n- Design confortable de la coque\n- H 82 cm x L 57 cm x P 53 cm\n\nCette jolie chaise de salle à manger Dusk est issue de la collection de la marque néerlandaise WOOOD. Dusk a une apparence mince, élégante et conviviale, et un siège actif. Grâce à sa teinte grisâtre subtile, Dusk s\'intègre facilement dans différents styles d\'intérieur. Associez la chaise de salle à manger Dusk à une palette de couleurs foncées chic ou apportez de la convivialité à un intérieur blanc grâce à sa teinte grisâtre.\n\nMatériau\nLa chaise de salle à manger est recouverte d\'un riche tissu en velours (100% polyester). Avec un Martindale de 25 000, Dusk convient à un usage domestique intensif mais il est recommandé d\'éviter les objets pointus. La base de la chaise est en fer avec une finition noire mate.\n\nDimensions\nLa chaise de salle à manger Dusk a une hauteur d\'assise de 48 cm, une profondeur d\'assise de 43 cm et une largeur d\'assise de 48 cm à l\'avant du siège et de 25 cm à l\'arrière du siège. Les accoudoirs ont une hauteur de 73 cm et une largeur de 2,5 cm. Le pied a une hauteur de 43 cm. La chaise de salle à manger a une capacité de charge maximale de 150 kg. \n\nMaintenance\nDes rayures dans le tissu en velours ? Cela peut se produire en raison de la pression exercée sur le tissu par l\'emballage. Heureusement, vous pouvez facilement résoudre ce problème vous-même en passant le tissu à la vapeur (utilisez votre fer à vapeur par exemple) ou en l\'aspergeant d\'eau. Vous pouvez ensuite brosser le tissu avec une brosse douce et propre. Les pôles du tissu sont ainsi restaurés ! Vous nettoyez le velours chaque semaine avec une brosse spéciale velours.\n\nDate de livraison\nPour les sols durs, placez des patins en feutre sous les pieds. Cela évite d\'endommager le sol. L\'article est livré sous forme de kit de construction simple avec des instructions de montage claires.',
        },
        de: {
            fullDescription: '- Eleganter, freundlicher Esszimmerstuhl- Samt (100% PES) mit schwarzem Eisenrahmen- Komfortables Schalendesign- H 82 cm x B 57 cm x T 53 cmDieser attraktive Dusk Esszimmerstuhl ist aus der Kollektion der niederländischen Marke WOOOD. Dusk hat ein elegantes und freundliches, schlankes Aussehen und einen aktiven Sitz. Durch den dezenten Grauton lässt sich Dusk leicht mit verschiedenen Einrichtungsstilen kombinieren. Kombinieren Sie den Dusk-Esszimmerstuhl mit einer schicken dunklen Farbpalette oder bringen Sie mit dem gräulichen Farbton Gemütlichkeit in eine weiße Einrichtung.MaterialDer Esszimmerstuhl ist mit einem reichhaltigen Samtstoff (100% Polyester) gepolstert. Mit einer Martindale von 25.000 ist Dusk für den intensiven Gebrauch zu Hause geeignet, aber es wird empfohlen, scharfe Gegenstände zu vermeiden. Das Gestell des Stuhls ist aus Eisen mit einer mattschwarzen Oberfläche gefertigt.AbmessungenDer Dusk Esszimmerstuhl hat eine Sitzhöhe von 48 cm, eine Sitztiefe von 43 cm und eine Sitzbreite von 48 cm an der Vorderseite des Sitzes und 25 cm an der Rückseite des Sitzes. Die Armlehnen sind 73 cm hoch und 2,5 cm breit. Das Bein hat eine Höhe von 43 cm. Der Esszimmerstuhl hat eine maximale Belastbarkeit von 150 kg. WartungStreifen im Samtstoff? Dies kann auf den Druck zurückzuführen sein, der durch die Verpackung auf den Stoff ausgeübt wurde. Zum Glück können Sie das Problem leicht selbst lösen, indem Sie den Stoff dämpfen (z. B. mit Ihrem Dampfbügeleisen) oder mit Wasser besprühen. Dann können Sie den Stoff mit einer sauberen, weichen Bürste abbürsten. Die Pole des Gewebes sind somit wiederhergestellt! Sie reinigen den Samt wöchentlich mit einer speziellen Samtbürste.LieferterminBei harten Böden sollten Sie Filzgleiter unter die Beine legen. Dadurch werden Schäden am Boden vermieden. Der Artikel wird als einfacher Bausatz mit einer klaren Montageanleitung geliefert.',
            name: 'DUSK ESSZIMMERSTUHL SAMT ALTROSA',
            slug: 'dusk-esszimmerstuhl-samt-altrosa',
            shortDescription: '- Eleganter, freundlicher Esszimmerstuhl\n- Samt (100% PES) mit schwarzem' +
                ' Eisenrahmen\n-' +
                ' Komfortables Schalendesign\n- H 82 cm x B 57 cm x T 53 cm\n\nDieser attraktive Dusk Esszimmerstuhl ist aus der Kollektion der niederländischen Marke WOOOD. Dusk hat ein elegantes und freundliches, schlankes Aussehen und einen aktiven Sitz. Durch den dezenten Grauton lässt sich Dusk leicht mit verschiedenen Einrichtungsstilen kombinieren. Kombinieren Sie den Dusk-Esszimmerstuhl mit einer schicken dunklen Farbpalette oder bringen Sie mit dem gräulichen Farbton Gemütlichkeit in eine weiße Einrichtung.\n\nMaterial\nDer Esszimmerstuhl ist mit einem reichhaltigen Samtstoff (100% Polyester) gepolstert. Mit einer Martindale von 25.000 ist Dusk für den intensiven Gebrauch zu Hause geeignet, aber es wird empfohlen, scharfe Gegenstände zu vermeiden. Das Gestell des Stuhls ist aus Eisen mit einer mattschwarzen Oberfläche gefertigt.\n\nAbmessungen\nDer Dusk Esszimmerstuhl hat eine Sitzhöhe von 48 cm, eine Sitztiefe von 43 cm und eine Sitzbreite von 48 cm an der Vorderseite des Sitzes und 25 cm an der Rückseite des Sitzes. Die Armlehnen sind 73 cm hoch und 2,5 cm breit. Das Bein hat eine Höhe von 43 cm. Der Esszimmerstuhl hat eine maximale Belastbarkeit von 150 kg. \n\nWartung\nStreifen im Samtstoff? Dies kann auf den Druck zurückzuführen sein, der durch die Verpackung auf den Stoff ausgeübt wurde. Zum Glück können Sie das Problem leicht selbst lösen, indem Sie den Stoff dämpfen (z. B. mit Ihrem Dampfbügeleisen) oder mit Wasser besprühen. Dann können Sie den Stoff mit einer sauberen, weichen Bürste abbürsten. Die Pole des Gewebes sind somit wiederhergestellt! Sie reinigen den Samt wöchentlich mit einer speziellen Samtbürste.\n\nLiefertermin\nBei harten Böden sollten Sie Filzgleiter unter die Beine legen. Dadurch werden Schäden am Boden vermieden. Der Artikel wird als einfacher Bausatz mit einer klaren Montageanleitung geliefert.',
        },
        nl: {
            fullDescription: '- Elegante, vriendelijke eetkamerstoel\n- Velvet (100% PES) met zwart ijzeren onderstel\n- Comfortabel kuip design\n- H 82 cm x B 57 cm x D 53 cm\n\nDeze sfeervolle eetkamerstoel Dusk komt uit de collectie van het Nederlandse merk WOOOD. Dusk heeft een elegante en vriendelijke, slanke uitstraling en een actieve zit. De subtiele vergrijsde tint maakt Dusk gemakkelijk te combineren in diverse interieurstijlen. Combineer de Dusk eetkamerstoel met een chique donker kleurenpallet of breng met de vergrijsde tint juist gezelligheid aan een wit interieur.\n\nMateriaal\nDe eetkamerstoel is bekleed met een rijke velvet stof (100% polyester). Met een Martindale van 25.000 is Dusk geschikt voor intensief woongebruik maar is het aangeraden om scherpe objecten te vermijden. Het onderstel van de eetkamerstoel is gemaakt van ijzer met een matzwarte afwerking.\n\nAfmetingen\nDe Dusk eetkamerstoel heeft een zithoogte van 48 cm, een zitdiepte van 43 cm en de zitbreedte is 48 cm aan de voorkant van de zitting en 25 cm aan de achterzijde van de zitting. De armleuningen zijn 73 cm hoog met een breedte van 2,5 cm. De poot heeft een hoogte van 43 cm. De eetkamerstoel heeft een maximaal draaggewicht van 150 kg. \n\nOnderhoud\nStrepen in de velvet stof? Dit kan gebeuren door de druk die op de stof is uitgeoefend door de verpakking. Gelukkig kun je dit eenvoudig zelf oplossen door de stof te stomen (gebruik hiervoor bijvoorbeeld je stoomstrijkijzer) of te benevelen met vocht. Vervolgens kun je de stof met een schone zachte borstel borstelen. De polen van de stof worden zo weer hersteld! Je houdt velvet wekelijks schoon met een speciale fluweelborstel.\n\nLevering\nPlaats bij harde vloeren viltglijders onder de poten. Dit voorkomt beschadigingen aan de vloer. Het artikel wordt geleverd als eenvoudig bouwpakket met een duidelijke montage-instructie.',
            name: 'DUSK EETKAMERSTOEL VELVET OUD ROZE',
            slug: 'dusk-eetkamerstoel-velvet-oud-roze',
            shortDescription: '',
        },
    },
    fsc: true,
}

export const mockPrice = {
    productPrices: [
        {
            ean: 'test',
            price: 10000,
            standardPrice: 10000,
            quantity: 1,
        },
    ],
}

export const mockAlgoliaProduct: Product = {
    id: '430',
    uniqueHash: '8127634430',
    name: 'DUSK DINING CHAIR VELVET OLD PINK',
    totalPackages: '1',
    packages: [
        {
            ean: '8714713118120',
            productCode: '131123',
            weightInKg: 123,
            depthInMm: 123,
            lengthMm: 123,
            volM3: 123,
            widthMm: 123,
            quantity: 123,
        },
    ],
    status: 'SALE',
    ean: '8714713118120',
    slug: 'some-slug-here',
    codeLocal: '200292-C',
    inStock: true,
    deliveryTimeInWeeks: 4,
    newProduct: false,
    collectionName: 'COLLECTION',
    dimensions: {
        diameter: 82,
        height: 82,
        width: 57,
        length: 53,
        units: DimensionUnits.cm,
    },
    primaryImage: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
    wideImage: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
    ambianceImage: 'https://www.deeekhoorn.com/assets/PRODUCT_IMAGES/8714713118120.jpg',
    inFavourites: false,
    suggestedRetailPrice: 10000,
    suggestedStandardRetailPrice: 10000,
    suggestedRetailPriceISE: 10000,
    suggestedStandardRetailPriceISE: 10000,
    debtorPrice: 12000,
    newDebtorPrice: 12000,
    brand: 'WOOOD',
    colors: [
        {
            name: 'red',
            presentation: '#FF0000',
        },
        {
            name: 'green',
            presentation: '#44e000',
        },
    ],
    subColors: [
        {
            name: 'red',
            presentation: '#FF0000',
        },
        {
            name: 'green',
            presentation: '#44e000',
        },
    ],
    materials: [
        'wood',
        'not wood',
    ],
    subMaterials: [
        'wood',
        'not wood',
    ],
    fsc: true,
    statusEnum: 'MADE TO ORDER',
}

export const mockCategory: CategoryFragment = {
    id: 'a0a52f3c-9b10-4558-ba8e-583055db0ace',
    published: true,
    translations: {
        en: {
            slug: 'sofas',
            name: 'Sofas',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
        fr: {
            slug: 'canap-s',
            name: 'Canapés',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
        de: {
            slug: 'sofas-couches',
            name: 'Sofas & Couches',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
        nl: {
            slug: 'banken',
            name: 'Banken',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
    },
    children: [
        {
            id: '362bd600-a5a7-4b4c-a852-403c361b4183',
            published: true,
            parentId: 'a0a52f3c-9b10-4558-ba8e-583055db0ace',
            translations: {
                en: {
                    slug: 'corner-sofas',
                    name: 'Corner Sofas',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                fr: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                de: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                nl: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
            },
        },
    ],
}

export const mockIndividualCategory: IndividualCategoryFragment = {
    id: 'a0a52f3c-9b10-4558-ba8e-583055db0ace',
    published: true,
    translations: {
        en: {
            slug: 'sofas',
            name: 'Sofas',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
            components: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
        },
        fr: {
            slug: 'canap-s',
            name: 'Canapés',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
            components: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
        },
        de: {
            slug: 'sofas-couches',
            name: 'Sofas & Couches',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
            components: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
        },
        nl: {
            slug: 'banken',
            name: 'Banken',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
            components: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
        },
    },
}

export const mockBrand: CompleteBrandFragment = {
    id: 1,
    name: 'Woood',
    slug: 'Woood',
    translations: {
        nl: {
            description: 'lorem',
            highlightedItem: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
            components: [],
        },
        de: {
            description: 'lorem',
            highlightedItem: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
            components: [],
        },
        fr: {
            description: 'lorem',
            highlightedItem: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
            components: [],
        },
        en: {
            description: 'lorem',
            highlightedItem: [],
            seo: {
                description: '',
                title: '',
                image: {
                    __typename: 'Image',
                    name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                    width: 3741,
                    height: 2494,
                    provider: 'aws-s3',
                    previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
                    alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
                },
                socials: [],
            },
            components: [],
        },
    },
}

export const mockTheme: ThemeFragment = {
    id: '1',
    name: 'Theme chair dummy',
    translations: {
        en: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'en',
        },
        fr: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'fr',
        },
        de: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'de',
        },
        nl: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'nl',
        },
    },
    seo: {
        title: 'the-ultimate-guide',
        keywords: null,
        description: 'the-ultimate-guide',
        robots: null,
        viewport: null,
        canonicalUrl: null,
        image: {
            __typename: 'Image',
            name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            width: 3741,
            height: 2494,
            provider: 'aws-s3',
            previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
        },
        socials: [],
    },
    components: [],
}

export const mockSimpleTheme: SimpleThemeFragment = {
    id: '1',
    name: 'Theme chair dummy',
    translations: {
        en: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'en',
            highlightedItem: [],
        },
        fr: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'fr',
            highlightedItem: [],
        },
        de: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'de',
            highlightedItem: [],
        },
        nl: {
            slug: 'outdoor',
            title: 'Outdoor',
            locale: 'nl',
            highlightedItem: [],
        },
    },
}

export const mockSimpleProducts: SimpleProductFragment[] = [
    {
        ean: '8714713142422',
        codeLocal: '370109-B',
        images: [],
        uniqueHash: '1',
        range: 'MEERT',
        brand: { name: 'brand' },
        statusTranslations: {
            en: 'test',
            de: 'test',
            fr: 'test',
            nl: 'test',
        },
        orderProperties: {
            deliveryInfo: { deliverableInWeeks: 1 },
            productOrderSteps: 1,
            productOrderStepDropshipment: 1,
        },
        dimensions: [],
        categories: [],
        stock: {
            ean: '8714713142422',
            quantity: 10,
            articleCode: '370109-B',
        },
        suggestedRetailPrices: [
            {
                price: 100,
                standardPrice: 100,
                type: SuggestedRetailPricesEnum.Nl,
            },
        ],
        translations: {
            en: {
                slug: 'meert-wall-shelf-50cm',
                name: 'MEERT WALL SHELF 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            de: {
                slug: 'meert-wandregal-metall-50cm',
                name: 'MEERT WANDREGAL METALL 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            fr: {
                slug: 'meert-tag-re-en-m-tal-50cm',
                name: 'MEERT ÉTAGÈRE EN MÉTAL 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            nl: {
                slug: 'meert-wandplank-goud-50cm',
                name: 'MEERT WANDPLANK GOUD 50CM',
                fullDescription: '',
                shortDescription: '',
            },
        },
        fsc: true,
        status: 'COLLECTION',
        colors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        subColors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        materials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
        subMaterials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
    },
    {
        ean: '8714713149063',
        codeLocal: '370109-Z',
        images: [],
        uniqueHash: '1',
        range: 'MEERT',
        brand: { name: 'brand' },
        dimensions: [],
        categories: [],
        stock: {
            ean: '8714713149063',
            quantity: 10,
            articleCode: '370109-Z',
        },
        statusTranslations: {
            en: 'test',
            de: 'test',
            fr: 'test',
            nl: 'test',
        },
        orderProperties: {
            deliveryInfo: { deliverableInWeeks: 1 },
            productOrderSteps: 1,
            productOrderStepDropshipment: 1,
        },
        suggestedRetailPrices: [
            {
                price: 100,
                standardPrice: 100,
                type: SuggestedRetailPricesEnum.Nl,
            },
        ],
        translations: {
            en: {
                slug: 'meert-wall-shelf-50cm',
                name: 'MEERT WALL SHELF 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            de: {
                slug: 'meert-wandregal-metall-50cm',
                name: 'MEERT WANDREGAL METALL 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            fr: {
                slug: 'meert-tag-re-en-m-tal-50cm',
                name: 'MEERT ÉTAGÈRE EN MÉTAL 50CM',
                fullDescription: '',
                shortDescription: '',
            },
            nl: {
                slug: 'meert-wandplank-zwart-50cm',
                name: 'MEERT WANDPLANK ZWART 50CM',
                fullDescription: '',
                shortDescription: '',
            },
        },
        fsc: true,
        status: 'COLLECTION',
        colors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        subColors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        materials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
        subMaterials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
    },
    {
        ean: '8716834005495',
        codeLocal: '370110-Z',
        images: [],
        uniqueHash: '1',
        range: 'MEERT',
        brand: { name: 'brand' },
        dimensions: [],
        categories: [],
        stock: {
            ean: '8716834005495',
            quantity: 10,
            articleCode: '370110-Z',
        },
        orderProperties: {
            deliveryInfo: { deliverableInWeeks: 1 },
            productOrderSteps: 1,
            productOrderStepDropshipment: 1,
        },
        statusTranslations: {
            en: 'test',
            de: 'test',
            fr: 'test',
            nl: 'test',
        },
        suggestedRetailPrices: [
            {
                price: 100,
                standardPrice: 100,
                type: SuggestedRetailPricesEnum.Nl,
            },
        ],
        translations: {
            en: {
                slug: 'meert-wall-shelf-100cm',
                name: 'MEERT WALL SHELF 100CM',
                fullDescription: '',
                shortDescription: '',
            },
            de: {
                slug: 'meert-wandregal-100cm',
                name: 'MEERT WANDREGAL 100CM',
                fullDescription: '',
                shortDescription: '',
            },
            fr: {
                slug: 'meert-tag-re-en-m-tal-100cm',
                name: 'MEERT ÉTAGÈRE EN MÉTAL 100CM',
                fullDescription: '',
                shortDescription: '',
            },
            nl: {
                slug: 'meert-wandplank-zwart-100cm',
                name: 'MEERT WANDPLANK ZWART 100CM',
                fullDescription: '',
                shortDescription: '',
            },
        },
        fsc: true,
        status: 'COLLECTION',
        colors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        subColors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        materials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
        subMaterials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
    },
    {
        ean: '8714713089222',
        codeLocal: '375432-N',
        range: 'COLLECTION',
        brand: { name: 'brand' },
        dimensions: [],
        categories: [],
        stock: {
            ean: '8714713089222',
            quantity: 10,
            articleCode: '375432-N',
        },
        orderProperties: {
            deliveryInfo: { deliverableInWeeks: 1 },
            productOrderSteps: 1,
            productOrderStepDropshipment: 1,
        },
        statusTranslations: {
            en: 'test',
            de: 'test',
            fr: 'test',
            nl: 'test',
        },
        images: [],
        uniqueHash: '1',
        suggestedRetailPrices: [
            {
                price: 100,
                standardPrice: 100,
                type: SuggestedRetailPricesEnum.Nl,
            },
        ],
        translations: {
            en: {
                slug: 'lev-sidetable-wood-metal',
                name: 'LEV SIDETABLE WOOD/METAL',
                fullDescription: '',
                shortDescription: '',
            },
            de: {
                slug: 'lev-beistelltisch-holz-metal',
                name: 'LEV BEISTELLTISCH HOLZ/METAL',
                fullDescription: '',
                shortDescription: '',
            },
            fr: {
                slug: 'lev-table-bois-bois-m-tal',
                name: 'LEV TABLE BOIS/BOIS MÉTAL',
                fullDescription: '',
                shortDescription: '',
            },
            nl: {
                slug: 'lev-bijzettafel-hout-metaal',
                name: 'LEV BIJZETTAFEL HOUT/METAAL',
                fullDescription: '',
                shortDescription: '',
            },
        },
        fsc: true,
        status: 'COLLECTION',
        colors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        subColors: [
            {
                __typename: 'Color',
                translations: {
                    nl: 'red',
                    de: 'red',
                    fr: 'red',
                    en: 'red',
                },
                presentation: '#FF0000',
            },
            {
                __typename: 'Color',
                translations: {
                    nl: 'green',
                    de: 'green',
                    fr: 'green',
                    en: 'green',
                },
                presentation: '#44e000',
            },
        ],
        materials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
        subMaterials: [{
            nl: 'Wood',
            de: 'Wood',
            fr: 'Wood',
            en: 'Wood',
        }],
    },
]

export const mockAssortments: AssortmentFragment[] = [
    {
        id: '1',
        ean: '8714713152940',
        createdAt: '',
    },
    {
        id: '2',
        ean: '8714713147250',
        createdAt: '',
    },
    {
        id: '3',
        ean: '8714713147267',
        createdAt: '',
    },
]

export const mockOrders: SimpleOrderFragment[] = [{
    orderId: '2f2f48c2-8b51-48ec-8ee9-f8a544c09b47',
    status: OrderStateEnum.All,
    reference: 'test',
    orderNumber: '55496330',
    orderDate: '2022-09-20 09:44:01',
    orderLines: [
        {
            quantity: 2,
            deliveryDate: '2022-09-20 09:44:01',
        },
        {
            quantity: 2,
            deliveryDate: '2022-09-20 09:44:01',
        },
        {
            quantity: 2,
            deliveryDate: '2022-09-20 09:44:01',
        },
    ],
}]

export const mockSaleStatistics: SaleStatisticsFragment = {
    debtorId: '000000',
    date: '2023-01-20 10:00:21',
    type: StatisticTypeEnum.TotalItems,
    statistics: [
        {
            product: mockSimpleProducts[0],
            totalItems: 151,
            totalAmount: 146168,
        },
        {
            product: mockSimpleProducts[0],
            totalItems: 100,
            totalAmount: 35400,
        },
        {
            product: mockSimpleProducts[0],
            totalItems: 73,
            totalAmount: 85410,
        },
        {
            product: mockSimpleProducts[0],
            totalItems: 66,
            totalAmount: 6072,
        },
    ],
}

export const mockPaginatorInfoFragment: PaginatorInfoFragment = {
    count: 1,
    currentPage: 1,
    firstItem: 1,
    hasMorePages: false,
    lastItem: 1,
    lastPage: 1,
    perPage: 1,
    total: 1,
}

export const mockMinimalAssortments: MinimalAssortmentsFragment[] = [
    {
        id: '1',
        ean: 'test',
    },
    {
        id: '2',
        ean: 'test',
    },
    {
        id: '3',
        ean: 'test',
    },
    {
        id: '4',
        ean: 'test',
    },
]

export const mockContentCategories: ContentCategoryFragment[] = [
    {
        id: 'mock-content-category-1',
        translations: {
            en: {
                slug: 'beds',
                name: 'Beds',
            },
            fr: {
                slug: 'lits',
                name: 'Lits',
            },
            de: {
                slug: 'betten',
                name: 'Betten',
            },
            nl: {
                slug: 'bedden',
                name: 'Bedden',
            },
        },
    },
    {
        id: 'mock-content-category-2',
        translations: {
            en: {
                slug: 'garden',
                name: 'Garden',
            },
            fr: {
                slug: 'jardin',
                name: 'Jardin',
            },
            de: {
                slug: 'garten',
                name: 'Garten',
            },
            nl: {
                slug: 'tuinmeubelen',
                name: 'Tuinmeubelen',
            },
        },
    },
    {
        id: 'mock-content-category-3',
        translations: {
            en: {
                slug: 'chairs',
                name: 'Chairs',
            },
            fr: {
                slug: 'chaises',
                name: 'Chaises',
            },
            de: {
                slug: 'st-hle',
                name: 'Stühle',
            },
            nl: {
                slug: 'stoelen',
                name: 'Stoelen',
            },
        },
    },
    {
        id: 'mock-content-category-4',
        translations: {
            en: {
                slug: 'cabinets',
                name: 'Cabinets',
            },
            fr: {
                slug: 'armoires',
                name: 'Armoires',
            },
            de: {
                slug: 'schr-nke',
                name: 'Schränke',
            },
            nl: {
                slug: 'kasten',
                name: 'Kasten',
            },
        },
    },
    {
        id: 'mock-content-category-5',
        translations: {
            en: {
                slug: 'home-accessories',
                name: 'Home accessories',
            },
            fr: {
                slug: 'd-co',
                name: 'Déco',
            },
            de: {
                slug: 'deko',
                name: 'Deko',
            },
            nl: {
                slug: 'woonaccessoires',
                name: 'Woonaccessoires',
            },
        },
    },
    {
        id: 'mock-content-category-6',
        translations: {
            en: {
                slug: 'sofas',
                name: 'Sofas',
            },
            fr: {
                slug: 'canap-s',
                name: 'Canapés',
            },
            de: {
                slug: 'sofas-couches',
                name: 'Sofas & Couches',
            },
            nl: {
                slug: 'banken',
                name: 'Banken',
            },
        },
    },
    {
        id: 'mock-content-category-7',
        translations: {
            en: {
                slug: 'desks',
                name: 'Desks',
            },
            fr: {
                slug: 'bureaux',
                name: 'Bureaux',
            },
            de: {
                slug: 'schreibtische',
                name: 'Schreibtische',
            },
            nl: {
                slug: 'bureaus',
                name: 'Bureaus',
            },
        },
    },
    {
        id: 'mock-content-category-8',
        translations: {
            en: {
                slug: 'tables',
                name: 'Tables',
            },
            fr: {
                slug: 'tables',
                name: 'Tables',
            },
            de: {
                slug: 'tische',
                name: 'Tische',
            },
            nl: {
                slug: 'tafels',
                name: 'Tafels',
            },
        },
    },
    {
        id: 'mock-content-category-9',
        translations: {
            en: {
                slug: 'lighting',
                name: 'Lighting',
            },
            fr: {
                slug: 'luminaires',
                name: 'Luminaires',
            },
            de: {
                slug: 'beleuchtung',
                name: 'Beleuchtung',
            },
            nl: {
                slug: 'verlichting',
                name: 'Verlichting',
            },
        },
    },
]

export const mockCategoryWithHighlights: CategoryFragment = {
    id: 'a0a52f3c-9b10-4558-ba8e-583055db0ace',
    published: true,
    translations: {
        en: {
            slug: 'sofas',
            name: 'Sofas',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
            highlightedItem: [
                {
                    title: 'MEERT WALL SHELF 50CM',
                    link: {
                        label: 'MEERT WALL SHELF 50CM',
                        link: '/products/meert-wall-shelf-50cm',
                        target: LinkTargetEnum.Self,
                    },
                    image: {
                        name: 'placeholder',
                        width: 1,
                        height: 1,
                        url: 'https://example.com/product.jpg',
                        alt: 'MEERT WALL SHELF 50CM',
                        previewUrl: 'https://example.com/product.jpg',
                        provider: 'aws-s3',
                    },
                },
            ],
        },
        fr: {
            slug: 'canap-s',
            name: 'Canapés',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
        de: {
            slug: 'sofas-couches',
            name: 'Sofas & Couches',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
        nl: {
            slug: 'banken',
            name: 'Banken',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
        },
    },
    children: [
        {
            id: '362bd600-a5a7-4b4c-a852-403c361b4183',
            published: true,
            parentId: 'a0a52f3c-9b10-4558-ba8e-583055db0ace',
            translations: {
                en: {
                    slug: 'corner-sofas',
                    name: 'Corner Sofas',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                fr: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                de: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
                nl: {
                    slug: 'hoekbanken',
                    name: 'Hoekbanken',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis leo et orci consequat feugiat quis vitae lacus.',
                },
            },
        },
    ],
}

export const mockNewsItem: NewsFragment = {
    id: '1',
    locale: 'en',
    slug: 'the-ultimate-guide',
    title: 'the-ultimate-guide',
    description: 'desc',
    image: mockImage(400),
    seo: {
        title: 'the-ultimate-guide',
        keywords: null,
        description: 'the-ultimate-guide',
        robots: null,
        viewport: null,
        canonicalUrl: null,
        image: {
            __typename: 'Image',
            name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            width: 3741,
            height: 2494,
            provider: 'aws-s3',
            previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
        },
        socials: [],
    },
    components: [],
}

export const mockEventItem: EventFragment = {
    id: '1',
    locale: 'en',
    slug: 'the-ultimate-guide',
    title: 'the-ultimate-guide',
    description: 'desc',
    image: mockImage(400),
    seo: {
        title: 'the-ultimate-guide',
        keywords: null,
        description: 'the-ultimate-guide',
        robots: null,
        viewport: null,
        canonicalUrl: null,
        image: {
            __typename: 'Image',
            name: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            caption: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
            width: 3741,
            height: 2494,
            provider: 'aws-s3',
            previewUrl: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            url: 'https://eekhoorn-strapi-assets.s3.eu-central-1.amazonaws.com/niko_photos_t_GT_Vxe_Or_Rs_unsplash_95a84d87ed.jpeg',
            alt: 'niko-photos-tGTVxeOr_Rs-unsplash.jpeg',
        },
        socials: [],
    },
    components: [],
}

export const ShoppingCartNullState = {
    cartLine: [],
    totalItems: 0,
    total: 0,
}

export const mockShoppingCart: ShoppingCartFragment = {
    totalItems: 4,
    total: 116795,
    cartLine: [
        {
            id: '1',
            price: 15200,
            quantity: 3,
            subTotal: 15200,
            product: {
                ean: '8714713147212',
                codeLocal: '200282-TA',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 2,
                    productOrderStepDropshipment: 2,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
        },
        {
            price: 73095,
            quantity: 1,
            subTotal: 73095,
            id: '2',
            product: {
                ean: '8714713142187',
                codeLocal: '200301-CF',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-corner-sofa-left-fabric-fudge',
                        name: 'SILVIJN CORNER SOFA LEFT FABRIC FUDGE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-eckcouch-linken-fabric-fudge',
                        name: 'SILVIJN ECKCOUCH LINKEN FABRIC FUDGE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-canape-d-angle-gauche-fabric-fudge',
                        name: 'SILVIJN CANAPE D ANGLE GAUCHE FABRIC FUDGE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hoekbank-links-stof-fudge',
                        name: 'SILVIJN HOEKBANK LINKS STOF FUDGE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
        },
        {
            price: 15200,
            quantity: 1,
            subTotal: 15200,
            id: '3',
            product: {
                ean: '8714713147229',
                codeLocal: '200282-TT',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
        },
        {
            price: 13300,
            quantity: 1,
            subTotal: 13300,
            id: '4',
            product: {
                stock: { quantity: 1 },
                ean: '8714713147274',
                codeLocal: '200282-CG',
                brand: { name: 'test' },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-stof-graphite',
                        name: 'SILVIJN HOCKER 90x90CM STOF GRAPHITE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
        },
    ],
}

export const mockShipment: ShipmentSegment[] = [
    {
        products: [
            {
                ean: '8714713147212',
                codeLocal: '200282-TA',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 2,
                    productOrderStepDropshipment: 2,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
            {
                ean: '8714713142187',
                codeLocal: '200301-CF',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-corner-sofa-left-fabric-fudge',
                        name: 'SILVIJN CORNER SOFA LEFT FABRIC FUDGE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-eckcouch-linken-fabric-fudge',
                        name: 'SILVIJN ECKCOUCH LINKEN FABRIC FUDGE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-canape-d-angle-gauche-fabric-fudge',
                        name: 'SILVIJN CANAPE D ANGLE GAUCHE FABRIC FUDGE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hoekbank-links-stof-fudge',
                        name: 'SILVIJN HOEKBANK LINKS STOF FUDGE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
            {
                ean: '8714713147229',
                codeLocal: '200282-TT',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
            {
                ean: '8714713147274',
                codeLocal: '200282-CG',
                brand: { name: 'test' },
                stock: { quantity: 1 },
                images: [],
                orderProperties: {
                    deliveryInfo: {
                        weekYear: '18-2023',
                        weekNumber: 18,
                        deliverableInWeeks: 10,
                    },
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    salesUnit: 'ST/PCS',
                },
                translations: {
                    en: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    de: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    fr: {
                        slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                        fullDescription: '',
                    },
                    nl: {
                        slug: 'silvijn-hocker-90x90cm-stof-graphite',
                        name: 'SILVIJN HOCKER 90x90CM STOF GRAPHITE',
                        fullDescription: '',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
            },
        ],
        amount: 6,
        subTotal: 116795,
        week: 18,
        year: 2023,
        orderInfo: [
            {
                amount: 3,
                product: {
                    ean: '8714713147212',
                    codeLocal: '200282-TA',
                    brand: { name: 'test' },
                    stock: { quantity: 1 },
                    images: [],
                    orderProperties: {
                        deliveryInfo: {
                            deliverableInWeeks: 10,
                            weekNumber: 18,
                            weekYear: '18-2023',
                        },
                        productOrderSteps: 2,
                        productOrderStepDropshipment: 2,
                        salesUnit: 'ST/PCS',
                    },
                    translations: {
                        de: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                            slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        },
                        en: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                            slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        },
                        fr: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                            slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        },
                        nl: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ GREY',
                            slug: 'silvijn-hocker-90x90cm-boucl-grey',
                        },
                    },
                    status: '',
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            },
            {
                amount: 1,
                product: {
                    ean: '8714713142187',
                    codeLocal: '200301-CF',
                    brand: { name: 'test' },
                    stock: { quantity: 1 },
                    images: [],
                    orderProperties: {
                        deliveryInfo: {
                            deliverableInWeeks: 10,
                            weekNumber: 18,
                            weekYear: '18-2023',
                        },
                        productOrderSteps: 1,
                        productOrderStepDropshipment: 1,
                        salesUnit: 'ST/PCS',
                    },
                    translations: {
                        de: {
                            fullDescription: '',
                            name: 'SILVIJN ECKCOUCH LINKEN FABRIC FUDGE',
                            slug: 'silvijn-eckcouch-linken-fabric-fudge',
                        },
                        en: {
                            fullDescription: '',
                            name: 'SILVIJN CORNER SOFA LEFT FABRIC FUDGE',
                            slug: 'silvijn-corner-sofa-left-fabric-fudge',
                        },
                        fr: {
                            fullDescription: '',
                            name: 'SILVIJN CANAPE D ANGLE GAUCHE FABRIC FUDGE',
                            slug: 'silvijn-canape-d-angle-gauche-fabric-fudge',
                        },
                        nl: {
                            fullDescription: '',
                            name: 'SILVIJN HOEKBANK LINKS STOF FUDGE',
                            slug: 'silvijn-hoekbank-links-stof-fudge',
                        },
                    },
                    status: '',
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            },
            {
                amount: 1,
                product: {
                    ean: '8714713147229',
                    codeLocal: '200282-TT',
                    brand: { name: 'test' },
                    stock: { quantity: 1 },
                    images: [],
                    orderProperties: {
                        deliveryInfo: {
                            deliverableInWeeks: 10,
                            weekNumber: 18,
                            weekYear: '18-2023',
                        },
                        productOrderSteps: 1,
                        productOrderStepDropshipment: 1,
                        salesUnit: 'ST/PCS',
                    },
                    translations: {
                        de: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                            slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        },
                        en: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                            slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        },
                        fr: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                            slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        },
                        nl: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM BOUCLÉ TURTLE',
                            slug: 'silvijn-hocker-90x90cm-boucl-turtle',
                        },
                    },
                    status: '',
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            },
            {
                amount: 1,
                product: {
                    ean: '8714713147274',
                    codeLocal: '200282-CG',
                    brand: { name: 'test' },
                    stock: { quantity: 1 },
                    images: [],
                    orderProperties: {
                        deliveryInfo: {
                            deliverableInWeeks: 10,
                            weekNumber: 18,
                            weekYear: '18-2023',
                        },
                        productOrderSteps: 1,
                        productOrderStepDropshipment: 1,
                        salesUnit: 'ST/PCS',
                    },
                    translations: {
                        de: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                            slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        },
                        en: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                            slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        },
                        fr: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM FABRIC GRAPHITE',
                            slug: 'silvijn-hocker-90x90cm-fabric-graphite',
                        },
                        nl: {
                            fullDescription: '',
                            name: 'SILVIJN HOCKER 90x90CM STOF GRAPHITE',
                            slug: 'silvijn-hocker-90x90cm-stof-graphite',
                        },
                    },
                    status: '',
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            },
        ],
    },
]

export const mockAccordion: AccordionFragment = {
    title: 'Dummy',
    accordionItems: [],
    icon: IconEnum.Instagram,
    __typename: 'Accordion',
}

export const mockLinks: PageLinksFragment = {
    title: 'mock',
    pages: [],
    pagesLayout: PageLayoutEnum.BigButtons,
    __typename: 'PageLinks',
}

export const mockParagraphs: ParagraphsFragment = {
    __typename: 'Paragraphs',
    paragraphsLayout: ParagraphsLayoutEnum.DoubleColumn,
    showGrayBack: true,
    paragraphs: [
        {
            paragraph: '',
            title: '',
            subtitle: '',
            buttons: [],
        },
    ],
}

export const mockShipmentSegments: ShipmentSegment[][] = [
    [
        {
            products: [
                {
                    ean: '8714713165353',
                    codeLocal: '801244-B',
                    stock: { quantity: 50 },
                    brand: null,
                    images: [
                        {
                            __typename: 'ProductImage',
                            url: 'https://cdn.bfldr.com/IM77OMBG/at/98pfcp5983frnnn6m2ktwck/801244-B-01_VS_BP_Tub_schaal_metaal_antique_brass_EA.jpg?auto=webp&format=png&width=800',
                            type: ProductImageTypeEnum.Front,
                            alt: '801244-B-01_VS_BP_Tub_schaal_metaal_antique_brass_EA.jpg?auto=webp&format=png',
                        },
                    ],
                    translations: {
                        en: {
                            slug: 'tub-metal-bowl-antique-brass',
                            name: 'TUB METAL BOWL ANTIQUE BRASS',
                            fullDescription: '- Generous decorative bowl- Made of metal- Finished with an antique brass coating- H 31 cm x Ø 30 cmThe mysterious matt sheen of an antique brass coating continues to amaze. Again with this generous decorative bowl from the BePureHome collection. Tub has a coarse and robust design, but looks very elegant because of the matte gold colour. MaterialThe metal in our collections has various finishes, such as powder coating and brass/antique brass. The antique brass finishes in our collections are applied with a mix of copper and zinc on the metal, which can then be finished in a brushed look, matt or shiny. Antique brass gives a weathered golden appearance to the item.DimensionsThe Tub bowl has a height of 31 cm and is 30 cm in diameter. The large bowl has a height and depth of 14 cm, is 30 cm round at the top and 11 cm round at the bottom. The foot is 17 cm high and ø 11 cm excluding scales, the circumference is 18 cm including scales. The bottom is hollow.MaintenanceAll our metals in the collection have been thoroughly treated and do not require any re-treatment. Should the metal be damaged, please consult a specialised paint shop. Treated metal is easy to keep clean with a slightly damp cloth and a mild detergent, drying the surface afterwards will ensure a streak-free result.DeliveryThe decorative bowl is delivered per piece. The Tub dish is not tested water-resistant, please avoid this.',
                        },
                        fr: {
                            slug: 'tub-bol-metal-antique-brass',
                            name: 'TUB BOL MÉTAL ANTIQUE BRASS',
                            fullDescription: "- Un généreux bol décoratif- En métal- Fini avec un revêtement en laiton antique- H 31 cm x Ø 30 cmLe mystérieux éclat mat d'un revêtement en laiton antique continue de surprendre. Encore une fois avec ce généreux bol décoratif de la collection BePureHome. Le tube a un design grossier et robuste, mais il est très élégant grâce à sa couleur or mat. MatériauLe métal de nos collections présente différentes finitions, telles que le revêtement en poudre et le laiton/le laiton antique. Les finitions en laiton antique de nos collections sont appliquées avec un mélange de cuivre et de zinc sur le métal, qui peut ensuite être fini en aspect brossé, mat ou brillant. Le laiton antique donne un aspect doré et usé à l'article.DimensionsLe plat Tub a une hauteur de 31 cm et mesure 30 cm de diamètre. Le grand bol a une hauteur et une profondeur de 14 cm, est rond de 30 cm en haut et de 11 cm en bas. Le pied mesure 17 cm de haut et ø 11 cm sans les écailles, la circonférence est de 18 cm avec les écailles. Le fond est creux.MaintenanceTous nos métaux de la collection ont été soigneusement traités et ne nécessitent aucun retraitement. Si le métal est endommagé, veuillez consulter un atelier de peinture spécialisé. Le métal traité se nettoie facilement à l'aide d'un chiffon légèrement humide et d'un détergent doux. Le séchage de la surface permet d'obtenir un résultat sans traces.LivraisonLe bol décoratif est livré par pièce. Le plat de Tub n'est pas testé résistant à l'eau, veuillez l'éviter.",
                        },
                        de: {
                            slug: 'tub-schale-metall-antik-messing',
                            name: 'TUB SCHALE METALL ANTIK MESSING',
                            fullDescription: '- Großzügige dekorative Schale- Hergestellt aus Metall- Mit einer Beschichtung aus antikem Messing versehen- H 31 cm x Ø 30 cmDer geheimnisvolle matte Glanz einer antiken Messingbeschichtung verblüfft immer wieder. So auch mit dieser großzügigen Dekoschale aus der BePureHome-Kollektion. Die Wanne hat ein grobes und robustes Design, wirkt aber durch die matte Goldfarbe sehr elegant. MaterialDas Metall in unseren Kollektionen hat verschiedene Oberflächen, wie z.B. Pulverbeschichtung und Messing/Antikmessing. Die Antikmessing-Ausführungen unserer Kollektionen werden mit einer Mischung aus Kupfer und Zink auf das Metall aufgetragen, das dann gebürstet, matt oder glänzend ausgeführt werden kann. Antikes Messing verleiht dem Gegenstand ein verwittertes goldenes Aussehen.AbmessungenDie Wannenschale hat eine Höhe von 31 cm und einen Durchmesser von 30 cm. Die große Schale hat eine Höhe und Tiefe von 14 cm, ist oben 30 cm rund und unten 11 cm rund. Der Fuß ist 17 cm hoch und hat einen Durchmesser von 11 cm ohne Schuppen, der Umfang beträgt 18 cm mit Schuppen. Der Boden ist hohl.WartungAlle Metalle in unserer Sammlung wurden gründlich behandelt und müssen nicht nachbehandelt werden. Sollte das Metall beschädigt sein, wenden Sie sich bitte an eine spezialisierte Lackiererei. Behandeltes Metall lässt sich mit einem leicht angefeuchteten Tuch und einem milden Reinigungsmittel leicht reinigen; das anschließende Trocknen der Oberfläche sorgt für ein streifenfreies Ergebnis.LieferungDie dekorative Schale wird pro Stück geliefert. Die Wannenschale ist nicht wasserfest getestet, bitte vermeiden Sie dies.',
                        },
                        nl: {
                            slug: 'tub-schaal-metaal-antique-brass',
                            name: 'TUB SCHAAL METAAL ANTIQUE BRASS',
                            fullDescription: '- Royale decoratieschaal\n- Vervaardigd uit metaal\n- Afgewerkt met een antique brass coating\n- H 31 cm x Ø 30 cm\n\nDe mysterieuze matte glans van een antique brass coating blijft verwonderen. Ook weer bij deze royale decoratieschaal uit de BePureHome collectie. Tub heeft een grof en robuust design, maar oogt zeer elegant door de matgouden kleur. \n\nMateriaal\nHet metaal uit onze collecties kent diverse afwerkingen, zoals: een poedercoating en messing/antique brass. De antique brass finishes uit onze collecties worden met een mix van koper en zink aangebracht op het metaal, dit kan vervolgens worden afgewerkt in een geborstelde uitstraling, mat of glanzend. Antique brass geeft een verweerde gouden uitstraling aan het item.\n\nAfmetingen\nDe Tub schaal heeft een hoogte van 31 cm en is 30 cm in het rond. De grote kom heeft een hoogte en diepte van 14 cm, is bovenaan 30 cm rond en onderin 11 cm rond. De voet is 17 cm hoog en ø 11 cm exclusief schubben, inclusief schubben is de omtrek 18 cm. De onderzijde is hol.\n\nOnderhoud\nAl onze metalen uit de collectie zijn grondig behandeld en vragen dus niet om een herbehandeling. Mocht het metaal beschadigd zijn, raadpleeg dan een gespecialiseerde verfzaak. Behandeld metaal is eenvoudig schoon te houden met een lichtvochtige doek en een mild schoonmaakmiddel, het nadrogen van het oppervlak zorgt voor een streeploos resultaat.\n\nLevering\nDe decoratieschaal wordt per stuk geleverd. De Tub schaal is niet waterbestendig getest, hierom gelieve vermijden.',
                        },
                    },
                    status: '',
                    orderProperties: {
                        salesUnit: 'ST/PCS',
                        productOrderSteps: 1,
                        productOrderStepDropshipment: 1,
                        deliveryInfo: {
                            deliverableInWeeks: 0,
                            weekNumber: 26,
                            weekYear: '26-2023',
                        },
                    },
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            ],
            amount: 1,
            subTotal: 3330,
            week: 26,
            year: 1,
            orderInfo: [
                {
                    product: {
                        ean: '8714713165353',
                        codeLocal: '801244-B',
                        stock: { quantity: 50 },
                        brand: null,
                        images: [
                            {
                                __typename: 'ProductImage',
                                url: 'https://cdn.bfldr.com/IM77OMBG/at/98pfcp5983frnnn6m2ktwck/801244-B-01_VS_BP_Tub_schaal_metaal_antique_brass_EA.jpg?auto=webp&format=png&width=800',
                                type: ProductImageTypeEnum.Front,
                                alt: '801244-B-01_VS_BP_Tub_schaal_metaal_antique_brass_EA.jpg?auto=webp&format=png',
                            },
                        ],
                        translations: {
                            en: {
                                slug: 'tub-metal-bowl-antique-brass',
                                name: 'TUB METAL BOWL ANTIQUE BRASS',
                                fullDescription: '- Generous decorative bowl- Made of metal- Finished with an antique brass coating- H 31 cm x Ø 30 cmThe mysterious matt sheen of an antique brass coating continues to amaze. Again with this generous decorative bowl from the BePureHome collection. Tub has a coarse and robust design, but looks very elegant because of the matte gold colour. MaterialThe metal in our collections has various finishes, such as powder coating and brass/antique brass. The antique brass finishes in our collections are applied with a mix of copper and zinc on the metal, which can then be finished in a brushed look, matt or shiny. Antique brass gives a weathered golden appearance to the item.DimensionsThe Tub bowl has a height of 31 cm and is 30 cm in diameter. The large bowl has a height and depth of 14 cm, is 30 cm round at the top and 11 cm round at the bottom. The foot is 17 cm high and ø 11 cm excluding scales, the circumference is 18 cm including scales. The bottom is hollow.MaintenanceAll our metals in the collection have been thoroughly treated and do not require any re-treatment. Should the metal be damaged, please consult a specialised paint shop. Treated metal is easy to keep clean with a slightly damp cloth and a mild detergent, drying the surface afterwards will ensure a streak-free result.DeliveryThe decorative bowl is delivered per piece. The Tub dish is not tested water-resistant, please avoid this.',
                            },
                            fr: {
                                slug: 'tub-bol-metal-antique-brass',
                                name: 'TUB BOL MÉTAL ANTIQUE BRASS',
                                fullDescription: "- Un généreux bol décoratif- En métal- Fini avec un revêtement en laiton antique- H 31 cm x Ø 30 cmLe mystérieux éclat mat d'un revêtement en laiton antique continue de surprendre. Encore une fois avec ce généreux bol décoratif de la collection BePureHome. Le tube a un design grossier et robuste, mais il est très élégant grâce à sa couleur or mat. MatériauLe métal de nos collections présente différentes finitions, telles que le revêtement en poudre et le laiton/le laiton antique. Les finitions en laiton antique de nos collections sont appliquées avec un mélange de cuivre et de zinc sur le métal, qui peut ensuite être fini en aspect brossé, mat ou brillant. Le laiton antique donne un aspect doré et usé à l'article.DimensionsLe plat Tub a une hauteur de 31 cm et mesure 30 cm de diamètre. Le grand bol a une hauteur et une profondeur de 14 cm, est rond de 30 cm en haut et de 11 cm en bas. Le pied mesure 17 cm de haut et ø 11 cm sans les écailles, la circonférence est de 18 cm avec les écailles. Le fond est creux.MaintenanceTous nos métaux de la collection ont été soigneusement traités et ne nécessitent aucun retraitement. Si le métal est endommagé, veuillez consulter un atelier de peinture spécialisé. Le métal traité se nettoie facilement à l'aide d'un chiffon légèrement humide et d'un détergent doux. Le séchage de la surface permet d'obtenir un résultat sans traces.LivraisonLe bol décoratif est livré par pièce. Le plat de Tub n'est pas testé résistant à l'eau, veuillez l'éviter.",
                            },
                            de: {
                                slug: 'tub-schale-metall-antik-messing',
                                name: 'TUB SCHALE METALL ANTIK MESSING',
                                fullDescription: '- Großzügige dekorative Schale- Hergestellt aus Metall- Mit einer Beschichtung aus antikem Messing versehen- H 31 cm x Ø 30 cmDer geheimnisvolle matte Glanz einer antiken Messingbeschichtung verblüfft immer wieder. So auch mit dieser großzügigen Dekoschale aus der BePureHome-Kollektion. Die Wanne hat ein grobes und robustes Design, wirkt aber durch die matte Goldfarbe sehr elegant. MaterialDas Metall in unseren Kollektionen hat verschiedene Oberflächen, wie z.B. Pulverbeschichtung und Messing/Antikmessing. Die Antikmessing-Ausführungen unserer Kollektionen werden mit einer Mischung aus Kupfer und Zink auf das Metall aufgetragen, das dann gebürstet, matt oder glänzend ausgeführt werden kann. Antikes Messing verleiht dem Gegenstand ein verwittertes goldenes Aussehen.AbmessungenDie Wannenschale hat eine Höhe von 31 cm und einen Durchmesser von 30 cm. Die große Schale hat eine Höhe und Tiefe von 14 cm, ist oben 30 cm rund und unten 11 cm rund. Der Fuß ist 17 cm hoch und hat einen Durchmesser von 11 cm ohne Schuppen, der Umfang beträgt 18 cm mit Schuppen. Der Boden ist hohl.WartungAlle Metalle in unserer Sammlung wurden gründlich behandelt und müssen nicht nachbehandelt werden. Sollte das Metall beschädigt sein, wenden Sie sich bitte an eine spezialisierte Lackiererei. Behandeltes Metall lässt sich mit einem leicht angefeuchteten Tuch und einem milden Reinigungsmittel leicht reinigen; das anschließende Trocknen der Oberfläche sorgt für ein streifenfreies Ergebnis.LieferungDie dekorative Schale wird pro Stück geliefert. Die Wannenschale ist nicht wasserfest getestet, bitte vermeiden Sie dies.',
                            },
                            nl: {
                                slug: 'tub-schaal-metaal-antique-brass',
                                name: 'TUB SCHAAL METAAL ANTIQUE BRASS',
                                fullDescription: '- Royale decoratieschaal\n- Vervaardigd uit metaal\n- Afgewerkt met een antique brass coating\n- H 31 cm x Ø 30 cm\n\nDe mysterieuze matte glans van een antique brass coating blijft verwonderen. Ook weer bij deze royale decoratieschaal uit de BePureHome collectie. Tub heeft een grof en robuust design, maar oogt zeer elegant door de matgouden kleur. \n\nMateriaal\nHet metaal uit onze collecties kent diverse afwerkingen, zoals: een poedercoating en messing/antique brass. De antique brass finishes uit onze collecties worden met een mix van koper en zink aangebracht op het metaal, dit kan vervolgens worden afgewerkt in een geborstelde uitstraling, mat of glanzend. Antique brass geeft een verweerde gouden uitstraling aan het item.\n\nAfmetingen\nDe Tub schaal heeft een hoogte van 31 cm en is 30 cm in het rond. De grote kom heeft een hoogte en diepte van 14 cm, is bovenaan 30 cm rond en onderin 11 cm rond. De voet is 17 cm hoog en ø 11 cm exclusief schubben, inclusief schubben is de omtrek 18 cm. De onderzijde is hol.\n\nOnderhoud\nAl onze metalen uit de collectie zijn grondig behandeld en vragen dus niet om een herbehandeling. Mocht het metaal beschadigd zijn, raadpleeg dan een gespecialiseerde verfzaak. Behandeld metaal is eenvoudig schoon te houden met een lichtvochtige doek en een mild schoonmaakmiddel, het nadrogen van het oppervlak zorgt voor een streeploos resultaat.\n\nLevering\nDe decoratieschaal wordt per stuk geleverd. De Tub schaal is niet waterbestendig getest, hierom gelieve vermijden.',
                            },
                        },
                        status: '',
                        orderProperties: {
                            salesUnit: 'ST/PCS',
                            productOrderSteps: 1,
                            productOrderStepDropshipment: 1,
                            deliveryInfo: {
                                deliverableInWeeks: 0,
                                weekNumber: 26,
                                weekYear: '26-2023',
                            },
                        },
                        categories: [],
                        parentCategory: {
                            translations: {
                                en: { name: 'Lorem' },
                                de: { name: 'Lorem' },
                                fr: { name: 'Lorem' },
                                nl: { name: 'Lorem' },
                            },
                        },
                    },
                    amount: 1,
                },
            ],
        },
    ],
    [
        {
            products: [
                {
                    ean: '8714713059904',
                    codeLocal: '365593-W',
                    stock: { quantity: 50 },
                    brand: null,
                    images: [
                        {
                            __typename: 'ProductImage',
                            url: 'https://cdn.bfldr.com/IM77OMBG/at/bjkj8zxx4scmr9zv45nh7z/365593-W-01_VS_FA_Nikki_bedbank_wit_EA.jpg?auto=webp&format=png&width=800',
                            type: ProductImageTypeEnum.Front,
                            alt: '365593-W-01_VS_FA_Nikki_bedbank_wit_EA.jpg?auto=webp&format=png',
                        },
                    ],
                    translations: {
                        en: {
                            slug: 'nikki-sofabed-pine-white-fsc',
                            name: 'NIKKI SOFABED PINE WHITE [fsc]',
                            fullDescription: 'One person sofa bedMade from brushed pinewoodPart of the Nikki bedroom seriesH 73 x W 100 x D 208 cmWOOOD sofa bed Nikki (hxwxl) 73x100x208 cm is part of the bedroom series Nikki. Create the perfect bedroom with the Nikki series. Bedbank Nikki is perfect for the teenagers who spend a lot of time in their room. The bed is made from solid, FSC certified, pinewood lacquered in the colour white and has a brushed finish. When pine furniture is brushed, the grain is strongly accentuated and a lived-in surface is created. The bed is delivered without the Nikki storage drawer, slatted base and mattress. We recommend the slatted bed base 90x200 cm and the mattress Bonell 90x200x17 cm or Pocket spring 90x200x18 cm. Both mattresses offer great sleeping comfort for teenagers.Nikki seriesThe Nikki series is available in two colours, jade green and white lacquered. Choose one of the colours or make an exciting mix with both colours. In this Nikki series the following articles are available: bedside table, storage/mattress drawer, desk and wardrobe in jade green or white.DeliveryThis bed is delivered as a kit and is easy to assemble with the supplied assembly instructions.',
                        },
                        fr: {
                            slug: 'nikki-lit-canape-blanc-pin-fsc',
                            name: 'NIKKI LIT CANAPE BLANC PIN [fsc]',
                            fullDescription: 'Canapé-lit simpleFabriqué en bois de pin brosséUne partie de la série de chambres à coucher NikkiH 73 x L 100 x P 208 cmLe canapé-lit WOOOD Nikki (hxbxl) 73x100x208 cm fait partie de la série de chambres à coucher Nikki. Créez la chambre à coucher parfaite avec la série Nikki. Le lit Nikki est parfait pour les adolescents qui passent beaucoup de temps dans leur chambre. Le lit est fabriqué en pin massif, certifié FSC, laqué de couleur blanche et a une finition brossée. En brossant la surface du pin, le grain est fortement accentué et crée une surface vivante. Le lit est livré sans le tiroir de rangement Nikki, ni le sommier à lattes et le matelas. Nous recommandons un sommier à lattes 90x200 cm et un matelas Bonell 90x200x17 cm ou un matelas Pocket spring 90x200x18 cm. Ces deux matelas offrent un grand confort de sommeil pour les adolescents.La série NikkiLa série Nikki est disponible en deux couleurs, vert jade et blanc laqué. Choisissez une des couleurs ou faites un mélange excitant avec les deux couleurs. Dans cette série Nikki, les articles suivants sont disponibles : table de nuit, tiroir de rangement/matelas, bureau et armoire en vert jade ou en blanc.LivraisonCe lit est livré en kit et est facile à assembler grâce aux instructions de montage fournies.',
                        },
                        de: {
                            slug: 'nikki-sofabett-kiefer-wei-fsc',
                            name: 'NIKKI SOFABETT KIEFER WEIß [fsc]',
                            fullDescription: 'Schlafsofa für eine PersonHergestellt aus gebürstetem KiefernholzTeil der Nikki-Schlafzimmer-SerieH 73 x B 100 x T 208 cmDas WOOOD Schlafsofa Nikki (hxbxl) 73x100x208 cm ist Teil der Schlafzimmerserie Nikki. Gestalten Sie das perfekte Schlafzimmer mit der Serie Nikki. Bedbank Nikki ist perfekt für Teenager, die viel Zeit in ihrem Zimmer verbringen. Das Bett ist aus massiver, FSC-zertifizierter, in der Farbe Weiß lackierter Kiefer gefertigt und hat eine gebürstete Oberfläche. Beim Bürsten von Kiefernmöbeln wird die Maserung stark akzentuiert und schafft eine lebendige Oberfläche. Das Bett wird ohne die Nikki-Stauschublade, den Lattenrost und die Matratze geliefert. Wir empfehlen einen Rolllattenrost oder Lattenrost 90x200 cm und eine Bonellmatratze 90x200x17 cm oder Taschenfederkernmatratze 90x200x18 cm. Beide Matratzen bieten einen hohen Schlafkomfort für Teenager.Nikki-SerieDie Serie Nikki ist in zwei Farben erhältlich, jadegrün und weiß lackiert. Wählen Sie eine der Farben oder machen Sie einen spannenden Mix mit beiden Farben. In dieser Nikki-Serie sind folgende Artikel erhältlich: Nachttisch, Ablage/Matratzenschublade, Schreibtisch und Kleiderschrank in Jadegrün oder Weiß.LieferungDieses Bett wird als Bausatz geliefert und ist mit der mitgelieferten Montageanleitung leicht zu montieren.',
                        },
                        nl: {
                            slug: 'nikki-bedbank-grenen-wit-excl-lade-fsc',
                            name: 'NIKKI BEDBANK GRENEN WIT (EXCL LADE) [fsc]',
                            fullDescription: 'Eén persoons bedbank\nVervaardigd uit geborsteld grenenhout\nOnderdeel van de Nikki slaapkamerserie\nH 73 x B 100 x D 208 cm\n\nWOOOD bedbank Nikki (hxbxl) 73x100x208 cm is een onderdeel van de slaapkamerserie Nikki. Creëer de perfecte slaapkamer met de serie Nikki. Bedbank Nikki is perfect voor de tieners die veel tijd op hun kamer vertoeven. Het bed is gemaakt van massief, FSC gecertificeerd, grenen gelakt in de kleur wit en heeft een geborstelde afwerking. Bij het borstelen van grenen meubelen wordt de nerf sterk geaccentueerd en ontstaat er een doorleefd oppervlak. Het bed wordt exclusief de Nikki opberg/matraslade, lattenbodem en matras geleverd. Bij dit bed wordt de lattenrolbodem of lamellen bedbodem 90x200 cm geadviseerd en het matras Bonell 90x200x17 cm of Pocketvering 90x200x18 cm. Beide matrassen bieden heerlijk slaapcomfort voor tieners.\n\nSerie Nikki\nDe serie Nikki is verkrijgbaar in twee kleuren jadegroen en wit gelakt. Kies voor één van de kleuren of maak een spannende mix met beide kleuren. In deze serie Nikki zijn de volgende artikelen verkrijgbaar: nachtkastje, opberg/matraslade, bureau en kledingkast in de kleuren jadegroen of wit.\n\nLevering\nDit bed wordt als bouwpakket geleverd en is makkelijk te monteren met behulp van de bijgeleverde montage instructie.',
                        },
                    },
                    orderProperties: {
                        salesUnit: 'ST/PCS',
                        productOrderSteps: 1,
                        productOrderStepDropshipment: 1,
                        deliveryInfo: {
                            deliverableInWeeks: 2,
                            weekNumber: 28,
                            weekYear: '28-2023',
                        },
                    },
                    status: '',
                    categories: [],
                    parentCategory: {
                        translations: {
                            en: { name: 'Lorem' },
                            de: { name: 'Lorem' },
                            fr: { name: 'Lorem' },
                            nl: { name: 'Lorem' },
                        },
                    },
                },
            ],
            amount: 1,
            subTotal: 14900,
            week: 28,
            year: 1,
            orderInfo: [
                {
                    product: {
                        ean: '8714713059904',
                        codeLocal: '365593-W',
                        stock: { quantity: 50 },
                        brand: null,
                        images: [
                            {
                                __typename: 'ProductImage',
                                url: 'https://cdn.bfldr.com/IM77OMBG/at/bjkj8zxx4scmr9zv45nh7z/365593-W-01_VS_FA_Nikki_bedbank_wit_EA.jpg?auto=webp&format=png&width=800',
                                type: ProductImageTypeEnum.Front,
                                alt: '365593-W-01_VS_FA_Nikki_bedbank_wit_EA.jpg?auto=webp&format=png',
                            },
                        ],
                        translations: {
                            en: {
                                slug: 'nikki-sofabed-pine-white-fsc',
                                name: 'NIKKI SOFABED PINE WHITE [fsc]',
                                fullDescription: 'One person sofa bedMade from brushed pinewoodPart of the Nikki bedroom seriesH 73 x W 100 x D 208 cmWOOOD sofa bed Nikki (hxwxl) 73x100x208 cm is part of the bedroom series Nikki. Create the perfect bedroom with the Nikki series. Bedbank Nikki is perfect for the teenagers who spend a lot of time in their room. The bed is made from solid, FSC certified, pinewood lacquered in the colour white and has a brushed finish. When pine furniture is brushed, the grain is strongly accentuated and a lived-in surface is created. The bed is delivered without the Nikki storage drawer, slatted base and mattress. We recommend the slatted bed base 90x200 cm and the mattress Bonell 90x200x17 cm or Pocket spring 90x200x18 cm. Both mattresses offer great sleeping comfort for teenagers.Nikki seriesThe Nikki series is available in two colours, jade green and white lacquered. Choose one of the colours or make an exciting mix with both colours. In this Nikki series the following articles are available: bedside table, storage/mattress drawer, desk and wardrobe in jade green or white.DeliveryThis bed is delivered as a kit and is easy to assemble with the supplied assembly instructions.',
                            },
                            fr: {
                                slug: 'nikki-lit-canape-blanc-pin-fsc',
                                name: 'NIKKI LIT CANAPE BLANC PIN [fsc]',
                                fullDescription: 'Canapé-lit simpleFabriqué en bois de pin brosséUne partie de la série de chambres à coucher NikkiH 73 x L 100 x P 208 cmLe canapé-lit WOOOD Nikki (hxbxl) 73x100x208 cm fait partie de la série de chambres à coucher Nikki. Créez la chambre à coucher parfaite avec la série Nikki. Le lit Nikki est parfait pour les adolescents qui passent beaucoup de temps dans leur chambre. Le lit est fabriqué en pin massif, certifié FSC, laqué de couleur blanche et a une finition brossée. En brossant la surface du pin, le grain est fortement accentué et crée une surface vivante. Le lit est livré sans le tiroir de rangement Nikki, ni le sommier à lattes et le matelas. Nous recommandons un sommier à lattes 90x200 cm et un matelas Bonell 90x200x17 cm ou un matelas Pocket spring 90x200x18 cm. Ces deux matelas offrent un grand confort de sommeil pour les adolescents.La série NikkiLa série Nikki est disponible en deux couleurs, vert jade et blanc laqué. Choisissez une des couleurs ou faites un mélange excitant avec les deux couleurs. Dans cette série Nikki, les articles suivants sont disponibles : table de nuit, tiroir de rangement/matelas, bureau et armoire en vert jade ou en blanc.LivraisonCe lit est livré en kit et est facile à assembler grâce aux instructions de montage fournies.',
                            },
                            de: {
                                slug: 'nikki-sofabett-kiefer-wei-fsc',
                                name: 'NIKKI SOFABETT KIEFER WEIß [fsc]',
                                fullDescription: 'Schlafsofa für eine PersonHergestellt aus gebürstetem KiefernholzTeil der Nikki-Schlafzimmer-SerieH 73 x B 100 x T 208 cmDas WOOOD Schlafsofa Nikki (hxbxl) 73x100x208 cm ist Teil der Schlafzimmerserie Nikki. Gestalten Sie das perfekte Schlafzimmer mit der Serie Nikki. Bedbank Nikki ist perfekt für Teenager, die viel Zeit in ihrem Zimmer verbringen. Das Bett ist aus massiver, FSC-zertifizierter, in der Farbe Weiß lackierter Kiefer gefertigt und hat eine gebürstete Oberfläche. Beim Bürsten von Kiefernmöbeln wird die Maserung stark akzentuiert und schafft eine lebendige Oberfläche. Das Bett wird ohne die Nikki-Stauschublade, den Lattenrost und die Matratze geliefert. Wir empfehlen einen Rolllattenrost oder Lattenrost 90x200 cm und eine Bonellmatratze 90x200x17 cm oder Taschenfederkernmatratze 90x200x18 cm. Beide Matratzen bieten einen hohen Schlafkomfort für Teenager.Nikki-SerieDie Serie Nikki ist in zwei Farben erhältlich, jadegrün und weiß lackiert. Wählen Sie eine der Farben oder machen Sie einen spannenden Mix mit beiden Farben. In dieser Nikki-Serie sind folgende Artikel erhältlich: Nachttisch, Ablage/Matratzenschublade, Schreibtisch und Kleiderschrank in Jadegrün oder Weiß.LieferungDieses Bett wird als Bausatz geliefert und ist mit der mitgelieferten Montageanleitung leicht zu montieren.',
                            },
                            nl: {
                                slug: 'nikki-bedbank-grenen-wit-excl-lade-fsc',
                                name: 'NIKKI BEDBANK GRENEN WIT (EXCL LADE) [fsc]',
                                fullDescription: 'Eén persoons bedbank\nVervaardigd uit geborsteld grenenhout\nOnderdeel van de Nikki slaapkamerserie\nH 73 x B 100 x D 208 cm\n\nWOOOD bedbank Nikki (hxbxl) 73x100x208 cm is een onderdeel van de slaapkamerserie Nikki. Creëer de perfecte slaapkamer met de serie Nikki. Bedbank Nikki is perfect voor de tieners die veel tijd op hun kamer vertoeven. Het bed is gemaakt van massief, FSC gecertificeerd, grenen gelakt in de kleur wit en heeft een geborstelde afwerking. Bij het borstelen van grenen meubelen wordt de nerf sterk geaccentueerd en ontstaat er een doorleefd oppervlak. Het bed wordt exclusief de Nikki opberg/matraslade, lattenbodem en matras geleverd. Bij dit bed wordt de lattenrolbodem of lamellen bedbodem 90x200 cm geadviseerd en het matras Bonell 90x200x17 cm of Pocketvering 90x200x18 cm. Beide matrassen bieden heerlijk slaapcomfort voor tieners.\n\nSerie Nikki\nDe serie Nikki is verkrijgbaar in twee kleuren jadegroen en wit gelakt. Kies voor één van de kleuren of maak een spannende mix met beide kleuren. In deze serie Nikki zijn de volgende artikelen verkrijgbaar: nachtkastje, opberg/matraslade, bureau en kledingkast in de kleuren jadegroen of wit.\n\nLevering\nDit bed wordt als bouwpakket geleverd en is makkelijk te monteren met behulp van de bijgeleverde montage instructie.',
                            },
                        },
                        status: '',
                        categories: [],
                        parentCategory: {
                            translations: {
                                en: { name: 'Lorem' },
                                de: { name: 'Lorem' },
                                fr: { name: 'Lorem' },
                                nl: { name: 'Lorem' },
                            },
                        },
                        orderProperties: {
                            salesUnit: 'ST/PCS',
                            productOrderSteps: 1,
                            productOrderStepDropshipment: 1,
                            deliveryInfo: {
                                deliverableInWeeks: 2,
                                weekNumber: 28,
                                weekYear: '28-2023',
                            },
                        },
                    },
                    amount: 1,
                },
            ],
        },
    ],
]

export const mockPaymentConditions: PaymentConditionFragment = {
    paymentCondition: '09',
    paymentConditionDescription: '30 DAGEN NETTO',
    francoLimit: '700',
    orderSurcharge: '37',
    minimumOrderLimit: '100',
    orderSupplement: '37',
    overrideLimits: '0',
    btwNumber: 'NL803355361B01',
    invoiceDebtorCode: '',
    dropShipmentShipmentPreferredCountryCode: 'NL',
    dropShipmentShipmentScales: [
        {
            locale: 'be',
            scales: [
                {
                    from: 5000,
                    to: 10000,
                    cost: 2208,
                },
                {
                    from: 60000,
                    to: 1000000,
                    cost: 9098,
                },
                {
                    from: 0,
                    to: 5000,
                    cost: 1378,
                },
                {
                    from: 40000,
                    to: 60000,
                    cost: 8472,
                },
                {
                    from: 15000,
                    to: 22500,
                    cost: 4593,
                },
                {
                    from: 10000,
                    to: 15000,
                    cost: 3041,
                },
                {
                    from: 22500,
                    to: 30000,
                    cost: 6475,
                },
                {
                    from: 30000,
                    to: 40000,
                    cost: 7190,
                },
            ],
        },
        {
            locale: 'de',
            scales: [
                {
                    from: 0,
                    to: 5000,
                    cost: 1412,
                },
                {
                    from: 22500,
                    to: 30000,
                    cost: 6450,
                },
                {
                    from: 5000,
                    to: 10000,
                    cost: 2046,
                },
                {
                    from: 10000,
                    to: 15000,
                    cost: 3344,
                },
                {
                    from: 40000,
                    to: 50000,
                    cost: 10697,
                },
                {
                    from: 100000,
                    to: 1000000,
                    cost: 23415,
                },
                {
                    from: 30000,
                    to: 40000,
                    cost: 8362,
                },
                {
                    from: 15000,
                    to: 22500,
                    cost: 5026,
                },
                {
                    from: 50000,
                    to: 75000,
                    cost: 13839,
                },
                {
                    from: 75000,
                    to: 100000,
                    cost: 17927,
                },
            ],
        },
        {
            locale: 'nl',
            scales: [
                {
                    from: 6000,
                    to: 10000,
                    cost: 1965,
                },
                {
                    from: 20000,
                    to: 35000,
                    cost: 4975,
                },
                {
                    from: 10000,
                    to: 20000,
                    cost: 3695,
                },
                {
                    from: 35000,
                    to: 50000,
                    cost: 5550,
                },
                {
                    from: 50000,
                    to: 1000000,
                    cost: 6999,
                },
                {
                    from: 0,
                    to: 6000,
                    cost: 1098,
                },
            ],
        },
    ],
}

export const mockDebtor: DebtorFragment = {
    name: 'The name',
    debtorCode: '012',
    debtorAddresses: [],
    debtorRights: {
        allowedModules: {
            dropShipment: true,
            datafeed: true,
            dontShowNewProducts: false,
            showNewFromDate: '',
        },
        allowedBrands: [{
            code: '4',
            description: 'test',
        }],
        allowedProductGroups: [{
            code: '4',
            description: 'test',
        }],
        allowedExclusives: [],
        allowedCountry: '',
    },
    paymentCondition: mockPaymentConditions,
}

export const mockShipmentSegment: ShipmentSegment = {
    products: [
        {
            ean: '8714713119516',
            codeLocal: '365561-Z',
            stock: { quantity: 33 },
            brand: { name: 'WOOOD' },
            images: [],
            translations: {
                en: {
                    slug: 'dennis-sofa-bed-brushed-black-ex.-beddrawer-fsc',
                    name: 'DENNIS SOFA BED BRUSHED BLACK (EX. BEDDRAWER) [fsc]',
                    fullDescription: '<p>Tough, robust sofa bed Solid, FSC certified, pine lacquered in black Bed drawer available separately H 73 x W 219 x D 101 cmHandy for a teenager, a sofa bed. Not only for sleeping, but also useful for gaming or watching TV in the bedroom. This Dennis sofa bed for one person, comes from the collection of the Dutch brand WOOOD. This sofa bed is made of, FSC certified, pine with a black finish and has a brushed finish giving the bed an extra robust and tough look. The bed can be extended with a handy storage drawer that can also be used as a guest bed (sold separately). The Dennis sofa bed is supplied without mattress (90x200) and slatted frame.This sofa bed is part of the Dennis bedroom, this room consists of a sofa bed or a bed without walls, a desk, a closet and a bedside table.BRUSHED WOOD This piece of furniture is made of brushed wood. The veins and knots are accentuated by brushing which gives the wood a lived through look. Because of this treatment, unevenness, small cracks and knots can be extra visible. These are characteristics of the lived through wood. Each specimen is therefore unique!The sofa bed is supplied as a construction kit with a clear assembly instruction. For hard floors, place felt glides under the legs. This prevents damage to the floor.</p>',
                },
                fr: {
                    slug: 'dennis-lit-canape-pin-brosse-noir-fsc',
                    name: 'DENNIS LIT CANAPE PIN BROSSE NOIR [fsc]',
                    fullDescription: "<p>Un canap&eacute;-lit robuste et r&eacute;sistant Solide, certifi&eacute; FSC, pin laqu&eacute; en noir Tiroir de lit disponible s&eacute;par&eacute;ment H 73 x P 219 x L 101 cmPratique pour un adolescent, un canap&eacute;-lit. Non seulement pour dormir, mais aussi pour jouer ou regarder la t&eacute;l&eacute;vision dans la chambre. Ce canap&eacute;-lit Dennis pour une personne, provient de la collection de la marque n&eacute;erlandaise WOOOD. Ce canap&eacute;-lit est fabriqu&eacute; en pin, certifi&eacute; FSC, avec une finition noire et une finition bross&eacute;e qui donne au lit un aspect particuli&egrave;rement robuste et r&eacute;sistant. Le lit peut &ecirc;tre prolong&eacute; par un tiroir de rangement pratique qui peut &eacute;galement &ecirc;tre utilis&eacute; comme lit d'appoint (vendu s&eacute;par&eacute;ment). Le canap&eacute;-lit Dennis est fourni sans matelas (90x200) et sans sommier &agrave; lattes.Ce canap&eacute;-lit fait partie de la chambre de Dennis, cette pi&egrave;ce est compos&eacute;e d'un canap&eacute;-lit ou d'un lit sans murs, d'un bureau, d'une armoire et d'une table de nuit.BOIS BROSS&Eacute; Ce meuble est en bois bross&eacute;. Les veines et les n&oelig;uds sont accentu&eacute;s par le brossage qui donne au bois un aspect vivant. En raison de ce traitement, les in&eacute;galit&eacute;s, les petites fissures et les n&oelig;uds peuvent &ecirc;tre encore plus visibles. Ce sont des caract&eacute;ristiques du v&eacute;cu &agrave; travers le bois. Chaque sp&eacute;cimen est donc unique !Le canap&eacute;-lit est fourni sous forme de kit de construction avec une instruction de montage claire. Sur les sols durs, placez des feutres qui glissent sous les jambes. Cela permet d'&eacute;viter les d&eacute;g&acirc;ts au sol.</p>",
                },
                de: {
                    slug: 'dennis-sofabett-schwarz-geburstet-exkl-bettkasten-fsc',
                    name: 'DENNIS SOFABETT SCHWARZ GEBÜRSTET (EXKL BETTKASTEN) [fsc]',
                    fullDescription: '<p>Robustes, widerstandsf&auml;higes Schlafsofa Massiv, FSC-zertifiziert, Kiefer schwarz lackiert Bettschublade separat erh&auml;ltlich H 73 x B 219 x T 101 cmPraktisch f&uuml;r einen Teenager, ein Schlafsofa. Nicht nur zum Schlafen, sondern auch zum Spielen oder Fernsehen im Schlafzimmer. Dieses Dennis-Bettsofa f&uuml;r eine Person, stammt aus der Kollektion der niederl&auml;ndischen Marke WOOOD. Dieses Bettsofa ist aus FSC-zertifizierter Kiefer mit schwarzer Oberfl&auml;che gefertigt und hat eine geb&uuml;rstete Oberfl&auml;che, die dem Bett ein besonders robustes und widerstandsf&auml;higes Aussehen verleiht. Das Bett kann mit einer praktischen Aufbewahrungsschublade erweitert werden, die auch als G&auml;stebett verwendet werden kann (separat erh&auml;ltlich). Das Schlafsofa Dennis wird ohne Matratze (90x200) und Lattenrost geliefert.Dieses Bettsofa ist Teil des Schlafzimmers Dennis, dieses Zimmer besteht aus einem Bettsofa oder einem Bett ohne W&auml;nde, einem Schreibtisch, einem Schrank und einem Nachttisch.GEB&Uuml;RSTETES HOLZ Dieses M&ouml;belst&uuml;ck ist aus geb&uuml;rstetem Holz gefertigt. Die Maserungen und &Auml;ste werden durch B&uuml;rsten akzentuiert, was dem Holz ein durchlebtes Aussehen verleiht. Aufgrund dieser Behandlung k&ouml;nnen Unebenheiten, kleine Risse und Knoten besonders sichtbar sein. Dies sind Merkmale des durchlebten Holzes. Jedes Exemplar ist also ein Unikat!Das Schlafsofa wird als Bausatz mit einer klaren Aufbauanleitung geliefert. Auf harten B&ouml;den Filzgleiter unter die Beine legen. Dadurch wird eine Besch&auml;digung des Bodens verhindert.</p>',
                },
                nl: {
                    slug: 'dennis-bedbank-zwart-excl-lade-fsc',
                    name: 'DENNIS BEDBANK ZWART (EXCL LADE) [fsc]',
                    fullDescription: 'Stoere, robuuste bedbank  \nMassief, FSC gecertificeerd, grenenhout afgelakt in het zwart \nBedlade apart verkrijgbaar   \nH 73 x B 219 x D 101 cm\n\nHandig voor een tiener, een bedbank. Niet alleen om te slapen, maar ook handig bij het gamen óf tv kijken op de slaapkamer. Deze Dennis bedbank voor één-persoon, komt uit de collectie van het Nederlandse merk WOOOD. Deze bedbank is gemaakt van, FSC gecertificeerd, grenenhout met een zwarte finish en heeft een geborstelde afwerking waardoor het bed een éxtra robuuste en stoere uitstraling krijgt. Het bed is uit te breiden met handige opberglade die ook gebruikt kan worden als logeerbed (apart verkrijgbaar). De Dennis bedbank wordt exclusief matras (90x200) en lattenbodem geleverd.\n\nDeze bedbank is onderdeel van de slaapkamer Dennis, deze kamer bestaat uit een bedbank of een bed zonder wanden, een bureau, een kast en een nachtkastje.\n\nGEBORSTELD HOUT \nDit meubel is gemaakt van geborsteld hout. De nerven en noesten worden door het borstelen geaccentueerd waardoor het hout een doorleefde uitstraling krijgt. Door deze bewerking kunnen oneffenheden, kleine scheurtjes en noesten extra zichtbaar zijn. Dit zijn kenmerken van het doorleefde hout. Ieder exemplaar is hierdoor uniek!\nDe bedbank wordt geleverd als bouwpakket met een duidelijke montage-instructie. Plaats bij harde vloeren viltglijders onder de poten. Dit voorkomt beschadigingen aan de vloer.\n',
                },
            },
            price: {
                ean: '8714713119516',
                price: 18432,
                standardPrice: 18432,
            },
            orderProperties: {
                salesUnit: 'ST/PCS',
                productOrderSteps: 1,
                productOrderStepDropshipment: 1,
                deliveryInfo: {
                    deliverableInWeeks: 1,
                    weekNumber: 30,
                    weekYear: '30-2023',
                },
            },
            status: '',
            categories: [],
            parentCategory: {
                translations: {
                    en: { name: 'Lorem' },
                    de: { name: 'Lorem' },
                    fr: { name: 'Lorem' },
                    nl: { name: 'Lorem' },
                },
            },
        },
        {
            ean: '8714713134625',
            codeLocal: '365568-Z',
            stock: { quantity: 50 },
            brand: { name: 'WOOOD' },
            images: [],
            translations: {
                en: {
                    slug: 'dennis-mattress-bed-drawer-black-brushed-fsc',
                    name: 'DENNIS MATTRESS / BED DRAWER BLACK BRUSHED [fsc]',
                    fullDescription: "Convenient storage drawer and/or guest bedBlack brushed solid, FSC certified, pineIdeal for the children's room for a guestH 21 x W 198 x D 91 cmMake clever use of space with this handy storage or guest bed drawer for under the bed Dennis in the colour black. This drawer is a standard storage drawer. When a slatted base with ribbon 90x200 and a mattress of 90x190x12 is added, the drawer can also be used as a guest bed.This article is supplied as a simple construction kit with clear assembly instructions.",
                },
                fr: {
                    slug: 'dennis-matelas-t-iroir-lit-pin-noir-fsc',
                    name: 'DENNIS MATELAS T/ IROIR LIT PIN NOIR [fsc]',
                    fullDescription: "Tiroir de rangement pratique et/ou lit d'invitéSolide brossé noir, certifié FSC, pinIdéal pour la chambre d'enfant d'un invitéH 21 x L 198 x P 91 cmUtilisez intelligemment l'espace avec ce tiroir de rangement ou de lit d'invité très pratique pour le dessous du lit Dennis en noir. Ce tiroir est un tiroir de rangement standard. Lorsqu'un sommier à lattes avec un ruban de 90x200 et un matelas de 90x190x12 est ajouté, le tiroir peut également servir de lit d'appoint.Cet article se présente sous la forme d'un simple kit avec des instructions de montage claires.",
                },
                de: {
                    slug: 'dennis-matratze-bettkasten-schwarz-geburstet-fsc',
                    name: 'DENNIS MATRATZE / BETTKASTEN SCHWARZ GEBÜRSTET [fsc]',
                    fullDescription: 'Praktische Stauschublade und/oder GästebettSchwarz gebürstet, massiv, FSC-zertifiziert, KieferIdeal für das Kinderzimmer für einen GastH 21 x B 198 x T 91 cmNutzen Sie den Platz clever aus mit diesem praktischen Stauraum- oder Gästebett-Schubkasten für unter dem Bett Dennis in Schwarz. Diese Schublade ist eine Standard-Lagerschublade. Bei Hinzunahme eines Lattenrostes mit Band 90x200 und einer Matratze 90x190x12 kann die Schublade auch als Gästebett genutzt werden.Dieser Artikel wird als einfacher Bausatz mit übersichtlicher Montageanleitung geliefert.',
                },
                nl: {
                    slug: 'dennis-matras-bedlade-zwart-geborsteld-fsc',
                    name: 'DENNIS MATRAS / BEDLADE ZWART GEBORSTELD [fsc]',
                    fullDescription: 'Handige opberglade en/of logeerbed\nZwart geborsteld massief, FSC gecertificeerd, grenenhout\nIdeaal voor op de kinderkamer voor een logé\nH 21 x B 198 x D 91 cm\n\nMaak slim gebruik van ruimte met deze handige opberg- of logeerbedlade voor onder het bed Dennis in de kleur zwart. Deze lade is standaard een opberglade. Wanneer er een lattenbodem met lint 90x200 en een matras van 90x190x12 wordt toegevoegd kan de lade ook worden gebruikt als logeerbed.\n\nDit artikel wordt geleverd als eenvoudig bouwpakket met duidelijke montagehandleiding.',
                },
            },
            price: {
                ean: '8714713134625',
                price: 7152,
                standardPrice: 18432,
            },
            orderProperties: {
                salesUnit: 'ST/PCS',
                productOrderSteps: 1,
                productOrderStepDropshipment: 1,
                deliveryInfo: {
                    deliverableInWeeks: 1,
                    weekNumber: 30,
                    weekYear: '30-2023',
                },
            },
            categories: [],
            parentCategory: {
                translations: {
                    en: { name: 'Lorem' },
                    de: { name: 'Lorem' },
                    fr: { name: 'Lorem' },
                    nl: { name: 'Lorem' },
                },
            },
            status: '',
        },
        {
            ean: '8714713071036',
            codeLocal: '390938-Z',
            stock: { quantity: 50 },
            brand: { name: 'WOOOD' },
            images: [],
            translations: {
                en: {
                    slug: 'teun-desk-with-drawer-metal-black',
                    name: 'TEUN DESK WITH DRAWER METAL BLACK',
                    fullDescription: "<p>WOOOD office Teun (hxbxd 76x110x50) is a modern version of a classic piece of furniture. Thanks to its sleek and industrial design, this desk fits into any interior. The Teun office has a black metal frame and a desk top made of black MDF. The Teun office is a great addition to both the (children's) bedroom and the living room. Tip In the case of hard floors, place felt glides under the metal frame. This prevents damage to hard floors. Delivery This item is supplied as a kit and is easy to assemble using the supplied installation instructions.</p>",
                },
                fr: {
                    slug: 'teun-bureau-avec-tiroir-metal-noir',
                    name: 'TEUN BUREAU AVEC TIROIR METAL NOIR',
                    fullDescription: "<p>Le bureau WOOOD Teun (hxlxd 76x110x50) est une version moderne d'un meuble classique. Avec son design &eacute;pur&eacute; et industriel, ce bureau s'int&egrave;gre &agrave; tous les int&eacute;rieurs. Le bureau Teun a un cadre en m&eacute;tal noir et un plateau en MDF noir. Le bureau Teun est un ajout cool &agrave; la fois dans la chambre (des enfants) et dans le salon. Conseil : pour les sols durs, placez des patins en feutre sous le cadre m&eacute;tallique. Cela &eacute;vite d'endommager les sols durs. Livraison : Cet article est livr&eacute; en kit et est facile &agrave; monter &agrave; l'aide des instructions de montage fournies.</p>",
                },
                de: {
                    slug: 'teun-schreibtisch-mit-schublad-metall-schwarz',
                    name: 'TEUN SCHREIBTISCH MIT SCHUBLAD METALL SCHWARZ',
                    fullDescription: '<p>Der WOOOD-Schreibtisch Teun (HxBxT 76x110x50) ist eine moderne Version eines klassischen M&ouml;belst&uuml;cks. Mit seinem schlichten und industriellen Design passt dieser Schreibtisch in jede Einrichtung. Der Schreibtisch Teun hat ein schwarzes Metallgestell und eine Tischplatte aus schwarzem MDF. Der Teun-Schreibtisch ist eine coole Erg&auml;nzung sowohl f&uuml;r das (Kinder-)Schlafzimmer als auch f&uuml;r das Wohnzimmer. Tipp: Bei harten B&ouml;den k&ouml;nnen Sie Filzgleiter unter den Metallrahmen legen. Dies verhindert Sch&auml;den an harten B&ouml;den. Lieferung: Dieser Artikel wird als Bausatz geliefert und ist mit Hilfe der mitgelieferten Montageanleitung leicht zu montieren.</p>',
                },
                nl: {
                    slug: 'teun-bureau-met-lade-zwart',
                    name: 'TEUN BUREAU MET LADE ZWART',
                    fullDescription: '<p>- D&eacute; musthave meubelserie van dit moment! - Ideale opbergers in een tijdloos design - Vervaardigd uit matzwart metaal - H 76 cm x B 110 cm x D 50 cm De Teun meubelserie uit de collectie van het Nederlandse interieurmerk WOOOD is een tijdloze musthave voor ieder interieur. De meubelserie is in te delen op maat, toon jouw boekencollectie in de open rekken en ga aan de slag aan dit stijlvolle bureau. Teun is perfect voor een multifunctionele kamerinrichting! Materiaal Het metaal uit onze collecties kennen diverse afwerkingen, zoals: een poedercoating. Een poedercoating zorgt voor een luxueuze uitstraling en beschermt het metaal levenslang. Een poedercoating is een lak welke met behulp van hoge temperaturen aan het metaal gehecht wordt. Een poedercoating zorgt voor een volledige kleurdekking en kent een matte of (licht)glanzende afwerking. Afmetingen - Hoogte: 76 cm - Breedte: 110 cm - Diepte: 50 cm - Framedikte: 2 cm - Lade front: H 10 x B 32 cm - Lade inhoud: H 5 x B 27 x D 33 cm De lade is vervaardigd uit MDF. - Draaggewicht lade: 9 kg - Draaggewicht bovenzijde: 30 kg - Gewicht: 13,8 kg Onderhoud Al onze metalen uit de collectie zijn grondig behandeld en vragen dus niet om een herbehandeling. Mocht het metaal beschadigd zijn, raadpleeg dan een gespecialiseerde verfzaak. Behandeld metaal is eenvoudig schoon te houden met een lichtvochtige doek en een mild schoonmaakmiddel, het nadrogen van het oppervlak zorgt voor een streeploos resultaat. Levering Het bureau wordt in &eacute;&eacute;n pakket geleverd en is eenvoudig te monteren aan de hand van de bijgeleverde montagehandleiding. Plaats voor het beschermen van harde vloeren viltglijders aan de onderzijde van het frame, dit voorkomt beschadigingen.</p>',
                },
            },
            status: '',
            price: {
                ean: '8714713071036',
                price: 4608,
                standardPrice: 18432,
            },
            orderProperties: {
                salesUnit: 'ST/PCS',
                productOrderSteps: 1,
                productOrderStepDropshipment: 1,
                deliveryInfo: {
                    deliverableInWeeks: 1,
                    weekNumber: 30,
                    weekYear: '30-2023',
                },
            },
            categories: [],
            parentCategory: {
                translations: {
                    en: { name: 'Lorem' },
                    de: { name: 'Lorem' },
                    fr: { name: 'Lorem' },
                    nl: { name: 'Lorem' },
                },
            },
        },
        {
            ean: '8714713107698',
            codeLocal: '373321-Z',
            stock: { quantity: 49 },
            brand: { name: 'WOOOD' },
            images: [],
            translations: {
                en: {
                    slug: 'duco-desk-black',
                    name: 'DUCO DESK BLACK',
                    fullDescription: 'Modern desk with a sturdy lookMDF black lacquered Convenient; with two storage shelvesH 74 cm x W 119 cm x D 51 cmDuco is a tough and modern desk from the collection of the Dutch brand WOOOD and is made of black lacquered MDF. The desk has two storage shelves. Dimensions of the top shelf (45 cm from the ground) are (wxd) 27x33 cm and of the bottom shelf (13 cm from the ground) are (wxd) 27x44 cm.  The space between the two shelves is 25 cm. Handy for storing your homework or hobby stuff. Duco has a 3 cm thick top that weighs 20 kg. The legs have a height of 71 cm with a diameter of 2 cm. The space between the compartments and the outer leg is 71 cm (take this into account when buying an office chair). Duco has a weight of 20 kg. The article is supplied as a simple kit with a clear assembly instruction. For hard floors, place felt glides under the legs. This prevents damage to the floor.',
                },
                fr: {
                    slug: 'duco-bureau-noir',
                    name: 'DUCO BUREAU NOIR',
                    fullDescription: "Bureau moderne à l'aspect robusteMDF laqué noir Pratique ; avec deux étagères de rangementH 74 cm x L 119 cm x P 51 cmDuco est un bureau robuste et moderne de la collection de la marque néerlandaise WOOOD et est fabriqué en MDF laqué noir. Le bureau dispose de deux étagères de rangement. Les dimensions de la tablette supérieure (45 cm du sol) sont de 27x33 cm (LxP) et de la tablette inférieure (13 cm du sol) de 27x44 cm (LxP).  L'espace entre les deux tablettes est de 25 cm. Pratique pour ranger vos devoirs ou vos articles de passe-temps. Duco a un plateau de 3 cm d'épaisseur qui pèse 20 kg. Les pieds ont une hauteur de 71 cm et un diamètre de 2 cm. L'espace entre les compartiments et le pied extérieur est de 71 cm (à prendre en compte lors de l'achat d'une chaise de bureau). Duco pèse 20 kg. L'article est fourni sous forme d'un kit simple avec une notice de montage claire. Pour les sols durs, placez le feutre sous les pieds. Ceci permet d'éviter d'endommager le sol.",
                },
                de: {
                    slug: 'duco-office-schwarz',
                    name: 'DUCO OFFICE SCHWARZ',
                    fullDescription: 'Moderner Schreibtisch in robuster OptikMDF schwarz lackiert Praktisch; mit zwei AblagefächernH 74 cm x B 119 cm x T 51 cm Duco ist ein robuster und moderner Schreibtisch aus der Kollektion der niederländischen Marke WOOOD und besteht aus schwarz lackiertem MDF. Der Schreibtisch hat zwei Ablagefächer. Die Abmessungen der oberen Ablage (45 cm vom Boden) betragen (BxT) 27x33 cm und der unteren Ablage (13 cm vom Boden) (BxT) 27x44 cm.  Der Abstand zwischen den beiden Regalen beträgt 25 cm. Praktisch zum Aufbewahren Ihrer Hausaufgaben oder Hobbysachen. Duco hat eine 3 cm dicke Platte mit einem Gewicht von 20 kg. Die Beine haben eine Höhe von 71 cm und einen Durchmesser von 2 cm. Der Abstand zwischen den Fächern und dem Außenbein beträgt 71 cm (beachten Sie dies beim Kauf eines Bürostuhls). Duco hat ein Gewicht von 20 kg. Der Artikel wird als einfacher Bausatz mit einer klaren Montageanleitung geliefert. Bei harten Böden legen Sie Filzgleiter unter die Beine. Dadurch wird eine Beschädigung des Bodens vermieden.',
                },
                nl: {
                    slug: 'duco-bureau-zwart',
                    name: 'DUCO BUREAU ZWART',
                    fullDescription: 'Modern bureau met stoere uitstraling\nMDF zwart afgelakt \nHandig: voorzien van twee opbergplanken\nH 74 cm x B 119 cm x D 51 cm\n\nDuco is een stoer en modern bureau uit de collectie van het Nederlandse merk WOOOD en is gemaakt van MDF dat zwart is afgelakt. Het bureau beschikt over een twee opbergplanken. Afmetingen van de bovenste plank (45 cm vanaf de grond) zijn (bxd) 27x33 cm en van de onderste plank (13 cm vanaf de grond)  zijn (bxd) 27x44 cm. De ruimte tussen de beide legplanken is 25 cm. Handig voor het opbergen van je huiswerk of hobby spullen. \n\nDuco heeft een blad van 3 cm dik dat een draaggewicht heeft van 20 kg. De poten hebben een hoogte van 71 cm met een diameter van 2 cm. De ruimte tussen het vakkengedeelte en de buitenste poot is 71 cm (houd hier rekening mee bij de aanschaf van een bureaustoel). \n\nDuco heeft een gewicht van 20 kg. \nHet artikel wordt geleverd als eenvoudig bouwpakket met een duidelijke montage-instructie. Plaats bij harde vloeren viltglijders onder de poten. Dit voorkomt beschadigingen aan de vloer.\n',
                },
            },
            status: '',
            price: {
                ean: '8714713107698',
                price: 6811,
                standardPrice: 18432,
            },
            orderProperties: {
                salesUnit: 'ST/PCS',
                productOrderSteps: 1,
                productOrderStepDropshipment: 1,
                deliveryInfo: {
                    deliverableInWeeks: 1,
                    weekNumber: 30,
                    weekYear: '30-2023',
                },
            },
            categories: [],
            parentCategory: {
                translations: {
                    en: { name: 'Lorem' },
                    de: { name: 'Lorem' },
                    fr: { name: 'Lorem' },
                    nl: { name: 'Lorem' },
                },
            },
        },
    ],
    amount: 4,
    subTotal: 37003,
    week: 30,
    year: 1,
    orderInfo: [
        {
            product: {
                ean: '8714713119516',
                codeLocal: '365561-Z',
                stock: { quantity: 33 },
                brand: { name: 'WOOOD' },
                images: [],
                translations: {
                    en: {
                        slug: 'dennis-sofa-bed-brushed-black-ex.-beddrawer-fsc',
                        name: 'DENNIS SOFA BED BRUSHED BLACK (EX. BEDDRAWER) [fsc]',
                        fullDescription: '<p>Tough, robust sofa bed Solid, FSC certified, pine lacquered in black Bed drawer available separately H 73 x W 219 x D 101 cmHandy for a teenager, a sofa bed. Not only for sleeping, but also useful for gaming or watching TV in the bedroom. This Dennis sofa bed for one person, comes from the collection of the Dutch brand WOOOD. This sofa bed is made of, FSC certified, pine with a black finish and has a brushed finish giving the bed an extra robust and tough look. The bed can be extended with a handy storage drawer that can also be used as a guest bed (sold separately). The Dennis sofa bed is supplied without mattress (90x200) and slatted frame.This sofa bed is part of the Dennis bedroom, this room consists of a sofa bed or a bed without walls, a desk, a closet and a bedside table.BRUSHED WOOD This piece of furniture is made of brushed wood. The veins and knots are accentuated by brushing which gives the wood a lived through look. Because of this treatment, unevenness, small cracks and knots can be extra visible. These are characteristics of the lived through wood. Each specimen is therefore unique!The sofa bed is supplied as a construction kit with a clear assembly instruction. For hard floors, place felt glides under the legs. This prevents damage to the floor.</p>',
                    },
                    fr: {
                        slug: 'dennis-lit-canape-pin-brosse-noir-fsc',
                        name: 'DENNIS LIT CANAPE PIN BROSSE NOIR [fsc]',
                        fullDescription: "<p>Un canap&eacute;-lit robuste et r&eacute;sistant Solide, certifi&eacute; FSC, pin laqu&eacute; en noir Tiroir de lit disponible s&eacute;par&eacute;ment H 73 x P 219 x L 101 cmPratique pour un adolescent, un canap&eacute;-lit. Non seulement pour dormir, mais aussi pour jouer ou regarder la t&eacute;l&eacute;vision dans la chambre. Ce canap&eacute;-lit Dennis pour une personne, provient de la collection de la marque n&eacute;erlandaise WOOOD. Ce canap&eacute;-lit est fabriqu&eacute; en pin, certifi&eacute; FSC, avec une finition noire et une finition bross&eacute;e qui donne au lit un aspect particuli&egrave;rement robuste et r&eacute;sistant. Le lit peut &ecirc;tre prolong&eacute; par un tiroir de rangement pratique qui peut &eacute;galement &ecirc;tre utilis&eacute; comme lit d'appoint (vendu s&eacute;par&eacute;ment). Le canap&eacute;-lit Dennis est fourni sans matelas (90x200) et sans sommier &agrave; lattes.Ce canap&eacute;-lit fait partie de la chambre de Dennis, cette pi&egrave;ce est compos&eacute;e d'un canap&eacute;-lit ou d'un lit sans murs, d'un bureau, d'une armoire et d'une table de nuit.BOIS BROSS&Eacute; Ce meuble est en bois bross&eacute;. Les veines et les n&oelig;uds sont accentu&eacute;s par le brossage qui donne au bois un aspect vivant. En raison de ce traitement, les in&eacute;galit&eacute;s, les petites fissures et les n&oelig;uds peuvent &ecirc;tre encore plus visibles. Ce sont des caract&eacute;ristiques du v&eacute;cu &agrave; travers le bois. Chaque sp&eacute;cimen est donc unique !Le canap&eacute;-lit est fourni sous forme de kit de construction avec une instruction de montage claire. Sur les sols durs, placez des feutres qui glissent sous les jambes. Cela permet d'&eacute;viter les d&eacute;g&acirc;ts au sol.</p>",
                    },
                    de: {
                        slug: 'dennis-sofabett-schwarz-geburstet-exkl-bettkasten-fsc',
                        name: 'DENNIS SOFABETT SCHWARZ GEBÜRSTET (EXKL BETTKASTEN) [fsc]',
                        fullDescription: '<p>Robustes, widerstandsf&auml;higes Schlafsofa Massiv, FSC-zertifiziert, Kiefer schwarz lackiert Bettschublade separat erh&auml;ltlich H 73 x B 219 x T 101 cmPraktisch f&uuml;r einen Teenager, ein Schlafsofa. Nicht nur zum Schlafen, sondern auch zum Spielen oder Fernsehen im Schlafzimmer. Dieses Dennis-Bettsofa f&uuml;r eine Person, stammt aus der Kollektion der niederl&auml;ndischen Marke WOOOD. Dieses Bettsofa ist aus FSC-zertifizierter Kiefer mit schwarzer Oberfl&auml;che gefertigt und hat eine geb&uuml;rstete Oberfl&auml;che, die dem Bett ein besonders robustes und widerstandsf&auml;higes Aussehen verleiht. Das Bett kann mit einer praktischen Aufbewahrungsschublade erweitert werden, die auch als G&auml;stebett verwendet werden kann (separat erh&auml;ltlich). Das Schlafsofa Dennis wird ohne Matratze (90x200) und Lattenrost geliefert.Dieses Bettsofa ist Teil des Schlafzimmers Dennis, dieses Zimmer besteht aus einem Bettsofa oder einem Bett ohne W&auml;nde, einem Schreibtisch, einem Schrank und einem Nachttisch.GEB&Uuml;RSTETES HOLZ Dieses M&ouml;belst&uuml;ck ist aus geb&uuml;rstetem Holz gefertigt. Die Maserungen und &Auml;ste werden durch B&uuml;rsten akzentuiert, was dem Holz ein durchlebtes Aussehen verleiht. Aufgrund dieser Behandlung k&ouml;nnen Unebenheiten, kleine Risse und Knoten besonders sichtbar sein. Dies sind Merkmale des durchlebten Holzes. Jedes Exemplar ist also ein Unikat!Das Schlafsofa wird als Bausatz mit einer klaren Aufbauanleitung geliefert. Auf harten B&ouml;den Filzgleiter unter die Beine legen. Dadurch wird eine Besch&auml;digung des Bodens verhindert.</p>',
                    },
                    nl: {
                        slug: 'dennis-bedbank-zwart-excl-lade-fsc',
                        name: 'DENNIS BEDBANK ZWART (EXCL LADE) [fsc]',
                        fullDescription: 'Stoere, robuuste bedbank  \nMassief, FSC gecertificeerd, grenenhout afgelakt in het zwart \nBedlade apart verkrijgbaar   \nH 73 x B 219 x D 101 cm\n\nHandig voor een tiener, een bedbank. Niet alleen om te slapen, maar ook handig bij het gamen óf tv kijken op de slaapkamer. Deze Dennis bedbank voor één-persoon, komt uit de collectie van het Nederlandse merk WOOOD. Deze bedbank is gemaakt van, FSC gecertificeerd, grenenhout met een zwarte finish en heeft een geborstelde afwerking waardoor het bed een éxtra robuuste en stoere uitstraling krijgt. Het bed is uit te breiden met handige opberglade die ook gebruikt kan worden als logeerbed (apart verkrijgbaar). De Dennis bedbank wordt exclusief matras (90x200) en lattenbodem geleverd.\n\nDeze bedbank is onderdeel van de slaapkamer Dennis, deze kamer bestaat uit een bedbank of een bed zonder wanden, een bureau, een kast en een nachtkastje.\n\nGEBORSTELD HOUT \nDit meubel is gemaakt van geborsteld hout. De nerven en noesten worden door het borstelen geaccentueerd waardoor het hout een doorleefde uitstraling krijgt. Door deze bewerking kunnen oneffenheden, kleine scheurtjes en noesten extra zichtbaar zijn. Dit zijn kenmerken van het doorleefde hout. Ieder exemplaar is hierdoor uniek!\nDe bedbank wordt geleverd als bouwpakket met een duidelijke montage-instructie. Plaats bij harde vloeren viltglijders onder de poten. Dit voorkomt beschadigingen aan de vloer.\n',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
                price: {
                    ean: '8714713119516',
                    price: 18432,
                    standardPrice: 18432,
                },
                orderProperties: {
                    salesUnit: 'ST/PCS',
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    deliveryInfo: {
                        deliverableInWeeks: 1,
                        weekNumber: 30,
                        weekYear: '30-2023',
                    },
                },
            },
            amount: 1,
        },
        {
            product: {
                ean: '8714713134625',
                codeLocal: '365568-Z',
                stock: { quantity: 50 },
                brand: { name: 'WOOOD' },
                images: [],
                translations: {
                    en: {
                        slug: 'dennis-mattress-bed-drawer-black-brushed-fsc',
                        name: 'DENNIS MATTRESS / BED DRAWER BLACK BRUSHED [fsc]',
                        fullDescription: "Convenient storage drawer and/or guest bedBlack brushed solid, FSC certified, pineIdeal for the children's room for a guestH 21 x W 198 x D 91 cmMake clever use of space with this handy storage or guest bed drawer for under the bed Dennis in the colour black. This drawer is a standard storage drawer. When a slatted base with ribbon 90x200 and a mattress of 90x190x12 is added, the drawer can also be used as a guest bed.This article is supplied as a simple construction kit with clear assembly instructions.",
                    },
                    fr: {
                        slug: 'dennis-matelas-t-iroir-lit-pin-noir-fsc',
                        name: 'DENNIS MATELAS T/ IROIR LIT PIN NOIR [fsc]',
                        fullDescription: "Tiroir de rangement pratique et/ou lit d'invitéSolide brossé noir, certifié FSC, pinIdéal pour la chambre d'enfant d'un invitéH 21 x L 198 x P 91 cmUtilisez intelligemment l'espace avec ce tiroir de rangement ou de lit d'invité très pratique pour le dessous du lit Dennis en noir. Ce tiroir est un tiroir de rangement standard. Lorsqu'un sommier à lattes avec un ruban de 90x200 et un matelas de 90x190x12 est ajouté, le tiroir peut également servir de lit d'appoint.Cet article se présente sous la forme d'un simple kit avec des instructions de montage claires.",
                    },
                    de: {
                        slug: 'dennis-matratze-bettkasten-schwarz-geburstet-fsc',
                        name: 'DENNIS MATRATZE / BETTKASTEN SCHWARZ GEBÜRSTET [fsc]',
                        fullDescription: 'Praktische Stauschublade und/oder GästebettSchwarz gebürstet, massiv, FSC-zertifiziert, KieferIdeal für das Kinderzimmer für einen GastH 21 x B 198 x T 91 cmNutzen Sie den Platz clever aus mit diesem praktischen Stauraum- oder Gästebett-Schubkasten für unter dem Bett Dennis in Schwarz. Diese Schublade ist eine Standard-Lagerschublade. Bei Hinzunahme eines Lattenrostes mit Band 90x200 und einer Matratze 90x190x12 kann die Schublade auch als Gästebett genutzt werden.Dieser Artikel wird als einfacher Bausatz mit übersichtlicher Montageanleitung geliefert.',
                    },
                    nl: {
                        slug: 'dennis-matras-bedlade-zwart-geborsteld-fsc',
                        name: 'DENNIS MATRAS / BEDLADE ZWART GEBORSTELD [fsc]',
                        fullDescription: 'Handige opberglade en/of logeerbed\nZwart geborsteld massief, FSC gecertificeerd, grenenhout\nIdeaal voor op de kinderkamer voor een logé\nH 21 x B 198 x D 91 cm\n\nMaak slim gebruik van ruimte met deze handige opberg- of logeerbedlade voor onder het bed Dennis in de kleur zwart. Deze lade is standaard een opberglade. Wanneer er een lattenbodem met lint 90x200 en een matras van 90x190x12 wordt toegevoegd kan de lade ook worden gebruikt als logeerbed.\n\nDit artikel wordt geleverd als eenvoudig bouwpakket met duidelijke montagehandleiding.',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
                price: {
                    ean: '8714713134625',
                    price: 7152,
                    standardPrice: 18432,
                },
                orderProperties: {
                    salesUnit: 'ST/PCS',
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    deliveryInfo: {
                        deliverableInWeeks: 1,
                        weekNumber: 30,
                        weekYear: '30-2023',
                    },
                },
            },
            amount: 1,
        },
        {
            product: {
                ean: '8714713071036',
                codeLocal: '390938-Z',
                stock: { quantity: 50 },
                brand: { name: 'WOOOD' },
                images: [],
                translations: {
                    en: {
                        slug: 'teun-desk-with-drawer-metal-black',
                        name: 'TEUN DESK WITH DRAWER METAL BLACK',
                        fullDescription: "<p>WOOOD office Teun (hxbxd 76x110x50) is a modern version of a classic piece of furniture. Thanks to its sleek and industrial design, this desk fits into any interior. The Teun office has a black metal frame and a desk top made of black MDF. The Teun office is a great addition to both the (children's) bedroom and the living room. Tip In the case of hard floors, place felt glides under the metal frame. This prevents damage to hard floors. Delivery This item is supplied as a kit and is easy to assemble using the supplied installation instructions.</p>",
                    },
                    fr: {
                        slug: 'teun-bureau-avec-tiroir-metal-noir',
                        name: 'TEUN BUREAU AVEC TIROIR METAL NOIR',
                        fullDescription: "<p>Le bureau WOOOD Teun (hxlxd 76x110x50) est une version moderne d'un meuble classique. Avec son design &eacute;pur&eacute; et industriel, ce bureau s'int&egrave;gre &agrave; tous les int&eacute;rieurs. Le bureau Teun a un cadre en m&eacute;tal noir et un plateau en MDF noir. Le bureau Teun est un ajout cool &agrave; la fois dans la chambre (des enfants) et dans le salon. Conseil : pour les sols durs, placez des patins en feutre sous le cadre m&eacute;tallique. Cela &eacute;vite d'endommager les sols durs. Livraison : Cet article est livr&eacute; en kit et est facile &agrave; monter &agrave; l'aide des instructions de montage fournies.</p>",
                    },
                    de: {
                        slug: 'teun-schreibtisch-mit-schublad-metall-schwarz',
                        name: 'TEUN SCHREIBTISCH MIT SCHUBLAD METALL SCHWARZ',
                        fullDescription: '<p>Der WOOOD-Schreibtisch Teun (HxBxT 76x110x50) ist eine moderne Version eines klassischen M&ouml;belst&uuml;cks. Mit seinem schlichten und industriellen Design passt dieser Schreibtisch in jede Einrichtung. Der Schreibtisch Teun hat ein schwarzes Metallgestell und eine Tischplatte aus schwarzem MDF. Der Teun-Schreibtisch ist eine coole Erg&auml;nzung sowohl f&uuml;r das (Kinder-)Schlafzimmer als auch f&uuml;r das Wohnzimmer. Tipp: Bei harten B&ouml;den k&ouml;nnen Sie Filzgleiter unter den Metallrahmen legen. Dies verhindert Sch&auml;den an harten B&ouml;den. Lieferung: Dieser Artikel wird als Bausatz geliefert und ist mit Hilfe der mitgelieferten Montageanleitung leicht zu montieren.</p>',
                    },
                    nl: {
                        slug: 'teun-bureau-met-lade-zwart',
                        name: 'TEUN BUREAU MET LADE ZWART',
                        fullDescription: '<p>- D&eacute; musthave meubelserie van dit moment! - Ideale opbergers in een tijdloos design - Vervaardigd uit matzwart metaal - H 76 cm x B 110 cm x D 50 cm De Teun meubelserie uit de collectie van het Nederlandse interieurmerk WOOOD is een tijdloze musthave voor ieder interieur. De meubelserie is in te delen op maat, toon jouw boekencollectie in de open rekken en ga aan de slag aan dit stijlvolle bureau. Teun is perfect voor een multifunctionele kamerinrichting! Materiaal Het metaal uit onze collecties kennen diverse afwerkingen, zoals: een poedercoating. Een poedercoating zorgt voor een luxueuze uitstraling en beschermt het metaal levenslang. Een poedercoating is een lak welke met behulp van hoge temperaturen aan het metaal gehecht wordt. Een poedercoating zorgt voor een volledige kleurdekking en kent een matte of (licht)glanzende afwerking. Afmetingen - Hoogte: 76 cm - Breedte: 110 cm - Diepte: 50 cm - Framedikte: 2 cm - Lade front: H 10 x B 32 cm - Lade inhoud: H 5 x B 27 x D 33 cm De lade is vervaardigd uit MDF. - Draaggewicht lade: 9 kg - Draaggewicht bovenzijde: 30 kg - Gewicht: 13,8 kg Onderhoud Al onze metalen uit de collectie zijn grondig behandeld en vragen dus niet om een herbehandeling. Mocht het metaal beschadigd zijn, raadpleeg dan een gespecialiseerde verfzaak. Behandeld metaal is eenvoudig schoon te houden met een lichtvochtige doek en een mild schoonmaakmiddel, het nadrogen van het oppervlak zorgt voor een streeploos resultaat. Levering Het bureau wordt in &eacute;&eacute;n pakket geleverd en is eenvoudig te monteren aan de hand van de bijgeleverde montagehandleiding. Plaats voor het beschermen van harde vloeren viltglijders aan de onderzijde van het frame, dit voorkomt beschadigingen.</p>',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
                price: {
                    ean: '8714713071036',
                    price: 4608,
                    standardPrice: 18432,
                },
                orderProperties: {
                    salesUnit: 'ST/PCS',
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    deliveryInfo: {
                        deliverableInWeeks: 1,
                        weekNumber: 30,
                        weekYear: '30-2023',
                    },
                },
            },
            amount: 1,
        },
        {
            product: {
                ean: '8714713107698',
                codeLocal: '373321-Z',
                stock: { quantity: 49 },
                brand: { name: 'WOOOD' },
                images: [],
                translations: {
                    en: {
                        slug: 'duco-desk-black',
                        name: 'DUCO DESK BLACK',
                        fullDescription: 'Modern desk with a sturdy lookMDF black lacquered Convenient; with two storage shelvesH 74 cm x W 119 cm x D 51 cmDuco is a tough and modern desk from the collection of the Dutch brand WOOOD and is made of black lacquered MDF. The desk has two storage shelves. Dimensions of the top shelf (45 cm from the ground) are (wxd) 27x33 cm and of the bottom shelf (13 cm from the ground) are (wxd) 27x44 cm.  The space between the two shelves is 25 cm. Handy for storing your homework or hobby stuff. Duco has a 3 cm thick top that weighs 20 kg. The legs have a height of 71 cm with a diameter of 2 cm. The space between the compartments and the outer leg is 71 cm (take this into account when buying an office chair). Duco has a weight of 20 kg. The article is supplied as a simple kit with a clear assembly instruction. For hard floors, place felt glides under the legs. This prevents damage to the floor.',
                    },
                    fr: {
                        slug: 'duco-bureau-noir',
                        name: 'DUCO BUREAU NOIR',
                        fullDescription: "Bureau moderne à l'aspect robusteMDF laqué noir Pratique ; avec deux étagères de rangementH 74 cm x L 119 cm x P 51 cmDuco est un bureau robuste et moderne de la collection de la marque néerlandaise WOOOD et est fabriqué en MDF laqué noir. Le bureau dispose de deux étagères de rangement. Les dimensions de la tablette supérieure (45 cm du sol) sont de 27x33 cm (LxP) et de la tablette inférieure (13 cm du sol) de 27x44 cm (LxP).  L'espace entre les deux tablettes est de 25 cm. Pratique pour ranger vos devoirs ou vos articles de passe-temps. Duco a un plateau de 3 cm d'épaisseur qui pèse 20 kg. Les pieds ont une hauteur de 71 cm et un diamètre de 2 cm. L'espace entre les compartiments et le pied extérieur est de 71 cm (à prendre en compte lors de l'achat d'une chaise de bureau). Duco pèse 20 kg. L'article est fourni sous forme d'un kit simple avec une notice de montage claire. Pour les sols durs, placez le feutre sous les pieds. Ceci permet d'éviter d'endommager le sol.",
                    },
                    de: {
                        slug: 'duco-office-schwarz',
                        name: 'DUCO OFFICE SCHWARZ',
                        fullDescription: 'Moderner Schreibtisch in robuster OptikMDF schwarz lackiert Praktisch; mit zwei AblagefächernH 74 cm x B 119 cm x T 51 cm Duco ist ein robuster und moderner Schreibtisch aus der Kollektion der niederländischen Marke WOOOD und besteht aus schwarz lackiertem MDF. Der Schreibtisch hat zwei Ablagefächer. Die Abmessungen der oberen Ablage (45 cm vom Boden) betragen (BxT) 27x33 cm und der unteren Ablage (13 cm vom Boden) (BxT) 27x44 cm.  Der Abstand zwischen den beiden Regalen beträgt 25 cm. Praktisch zum Aufbewahren Ihrer Hausaufgaben oder Hobbysachen. Duco hat eine 3 cm dicke Platte mit einem Gewicht von 20 kg. Die Beine haben eine Höhe von 71 cm und einen Durchmesser von 2 cm. Der Abstand zwischen den Fächern und dem Außenbein beträgt 71 cm (beachten Sie dies beim Kauf eines Bürostuhls). Duco hat ein Gewicht von 20 kg. Der Artikel wird als einfacher Bausatz mit einer klaren Montageanleitung geliefert. Bei harten Böden legen Sie Filzgleiter unter die Beine. Dadurch wird eine Beschädigung des Bodens vermieden.',
                    },
                    nl: {
                        slug: 'duco-bureau-zwart',
                        name: 'DUCO BUREAU ZWART',
                        fullDescription: 'Modern bureau met stoere uitstraling\nMDF zwart afgelakt \nHandig: voorzien van twee opbergplanken\nH 74 cm x B 119 cm x D 51 cm\n\nDuco is een stoer en modern bureau uit de collectie van het Nederlandse merk WOOOD en is gemaakt van MDF dat zwart is afgelakt. Het bureau beschikt over een twee opbergplanken. Afmetingen van de bovenste plank (45 cm vanaf de grond) zijn (bxd) 27x33 cm en van de onderste plank (13 cm vanaf de grond)  zijn (bxd) 27x44 cm. De ruimte tussen de beide legplanken is 25 cm. Handig voor het opbergen van je huiswerk of hobby spullen. \n\nDuco heeft een blad van 3 cm dik dat een draaggewicht heeft van 20 kg. De poten hebben een hoogte van 71 cm met een diameter van 2 cm. De ruimte tussen het vakkengedeelte en de buitenste poot is 71 cm (houd hier rekening mee bij de aanschaf van een bureaustoel). \n\nDuco heeft een gewicht van 20 kg. \nHet artikel wordt geleverd als eenvoudig bouwpakket met een duidelijke montage-instructie. Plaats bij harde vloeren viltglijders onder de poten. Dit voorkomt beschadigingen aan de vloer.\n',
                    },
                },
                status: '',
                categories: [],
                parentCategory: {
                    translations: {
                        en: { name: 'Lorem' },
                        de: { name: 'Lorem' },
                        fr: { name: 'Lorem' },
                        nl: { name: 'Lorem' },
                    },
                },
                price: {
                    ean: '8714713107698',
                    price: 6811,
                    standardPrice: 18432,
                },
                orderProperties: {
                    salesUnit: 'ST/PCS',
                    productOrderSteps: 1,
                    productOrderStepDropshipment: 1,
                    deliveryInfo: {
                        deliverableInWeeks: 1,
                        weekNumber: 30,
                        weekYear: '30-2023',
                    },
                },
            },
            amount: 1,
        },
    ],
}

export const mockPage = {
    data: {
        page: {
            slug: 'test-slug-en',
            id: 0,
            locale: 'en',
            seo: {

            } as unknown as Seo,
            components: [],
            title: 'Test Title',
            localizations: [
                {
                    locale: 'nl',
                    id: 1,
                    title: 'Test Titel',
                    slug: 'test-slug-nl',
                },
            ],
        },
    },
} as unknown as { data: PageQuery }

export const mockPositionedPage = {
    data: {
        positionedPages: [
            {
                identifier:'ABOUT_US',
                localizations: [
                    { id:1, title:'about us', locale:'en', slug:'about-us' },
                    { id:2, title:'over ons', locale:'nl', slug:'over-ons' },
                    { id:5, title:'Über uns', locale:'de', slug:'ueber-uns' },
                    { id:6, title:'À propos de nous', locale:'fr', slug:'a-propos-de-nous' },
                ],
            },
        ],
    },
}

export const mockProjects: ProjectSlideFragment[] = [
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
    {
        image: mockResponsiveImage(1),
        title: 'Eurovision Song Contest 2021',
        subtitle: 'Ahoy Rotterdam 2021',
        link: mockLink(),
    },
]

export const mockNewsLetter: NewsLetter = {
    category: NewsLetterTypeEnum.General,
    title: 'Interested in our newsletter?',
    subtitle: 'Subscribe to our newsletter',
}

export const mockfeatureHighlight: FeatureHighlight[] = [
    {
        position: {
            mobile: {
                x: 0.25,
                y: 0.25,
            },
            tablet: {
                x: 0.75,
                y: 0.75,
            },
        },
        preHeader: 'More to tell',
        header: 'a beautiful and rich velvet fabric',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in orci ligula. ' +
            'In nec enim vestibulum, congue mi id, sagittis nibh. Phasellus quam diam, ' +
            'varius in ornare venenatis, eleifend rutrum magna.',
    },
    {
        position: {
            mobile: {
                x: 0.75,
                y: 0.25,
            },
            tablet: {
                x: 0.75,
                y: 0.25,
            },
        },
        preHeader: 'More to tell',
        header: 'a beautiful and rich velvet fabric',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in orci ligula. ' +
            'In nec enim vestibulum, congue mi id, sagittis nibh. Phasellus quam diam, ' +
            'varius in ornare venenatis, eleifend rutrum magna.',
    },
    {
        position: {
            mobile: {
                x: 0.25,
                y: 0.75,
            },
            tablet: {
                x: 0.25,
                y: 0.75,
            },
        },
        preHeader: 'More to tell',
        header: 'a beautiful and rich velvet fabric',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in orci ligula. ' +
            'In nec enim vestibulum, congue mi id, sagittis nibh. Phasellus quam diam, ' +
            'varius in ornare venenatis, eleifend rutrum magna.',
    },
    {
        position: {
            mobile: {
                x: 0.75,
                y: 0.75,
            },
            tablet: {
                x: 0.25,
                y: 0.25,
            },
        },
        preHeader: 'More to tell',
        header: 'a beautiful and rich velvet fabric',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc in orci ligula. ' +
            'In nec enim vestibulum, congue mi id, sagittis nibh. Phasellus quam diam, ' +
            'varius in ornare venenatis, eleifend rutrum magna.',
    },
]

export const mockRegisterData = {
    input: {
        website: 'https://www.test.com',
        country: 'Netherlands',
        companyName: 'Test Company',
        consumerCompanyName: 'Test Consumer Company',
        city: 'Test City',
        email: 'test@test.com',
        name: 'Test Testington',
        phone: '01234567890',
        type: 'test',
        interested: ['WOOOD'],
        description: 'Test',
    },
}

export const mockAddressForm: AddressInput = {
    name: 'test',
    street: 'test',
    number: 'test',
    zipcode: 'test',
    city: 'test',
    country: 'test',
    phone: '424421421',
}
